import { Component } from "react";
import { connect } from "react-redux";
import { change, formValueSelector } from "redux-form";
import PageWithLayout from "../../containers/page";
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import Isvg from 'react-inlinesvg'
import { API_ENDPOINT } from '../../constants';
import { defaultError } from "../../components/TwoFactorAuthModal";
import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Input, Label, Table
} from 'reactstrap';
import { Link } from 'react-router-dom';
import ListBuilder from '../../components/listBuilder';
import DeleteModal from '../../components/deleteModal';
import InfoModal from '../../components/infoModal';
import FormBuilder from '../../components/forms/modalFormBuilder';
import { required } from '../../components/forms/validation';
import ErrorModal from '../../components/errorModal';

import ReferralClinics from '../../components/referralClinics';
import PrintHelper from '../../components/printHelper';
import DatePicker from '../../components/forms/fields/datePicker';
import TimePickerV2 from '../../components/forms/fields/timepicker_v2';

import billInfoIcon from '../../assets/svg/bill_info.svg';
import viewIcon from '../../assets/svg/eye.svg';
import xIcon from '../../assets/svg/x.svg';
import openChat from '../../assets/svg/open_chat.svg';
import ChatIcon from '../../assets/svg/chat-icon.svg'
import ChatIcon2 from '../../assets/svg/chatIcon2.svg'
import infoIcon from "../../assets/svg/link-new-tab.svg";
import Checkbox from '../../components/forms/fields/checkbox';
import transferIcon from '../../assets/svg/transfer-icon.svg';
import garbageIcon from '../../assets/svg/garbage.svg';
import historyIcon from '../../assets/svg/history-icon.svg';
import notesIcon from '../../assets/svg/notes-icon.svg';


import FormPreview from '../forms/previewAnsweredForm';


import ReferralContent from '../../components/referralContent';
import { isStringAValidNumber } from '../../components/TwoFactorAuthModal';
import ConsultationModal from '../../components/e-connect/ConsultationModal';
import ReferralStatusHistoryModal from "../../components/referralStatusHistoryModal";
import { showStatusHistoryButton } from "../../helpers/referral-statuses";
import DoctorListComponent from "../../components/forms/fields/doctorListComponent";
import PatientNotesPreview from "../../components/patientNotesPreview";
import ErrorModalV2 from '../../components/errorModal_v2';
import { checkRescheduleData } from "./helper";
import { isDurationHideCheckboxAvailable } from "../referral/helper";


function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

class ExternalBookingsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...(props?.initialData || {}),
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            items: [],
            disableFilterButtons: true,
            responseTimestamp: Math.floor(new Date().getTime()),
            groups: [],
            subgroups: [],
            total: 0,
            loading: true,
            activeRevisitForm: 1,
            changeButton: false,
            fields: [],
            doctorsList: [],
        }
    }

    get = () => {
        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, {
                entries: 10,
                page: 0,
                sortField: 'timestamp',
                sortType: -1,
                clinic: this.props.selectedClinic,
                recipientUser: this.props.uData._id,
                group: this.props.selectedGroup,

                scheduled: this.state.scheduled ? this.state.scheduled : false,
                notBooked: this.state.notBooked ? this.state.notBooked : false,
                requestedNewAppointment: this.state.requestedNewAppointment ? this.state.requestedNewAppointment : false,
                rejectedByPatient: this.state.rejectedByPatient ? this.state.rejectedByPatient : false,
                closed: this.state.closed ? this.state.closed : false,

                columnVisibility: 'external-bookings'
            })).then((data) => {
                if (!data || data.error) return this.setState({
                    error: data.error || defaultError,
                });

                let dataToSet = { ...data };
                if (dataToSet.page || dataToSet.items || dataToSet.total) {
                    dataToSet.loading = null;
                    // console.log(dataToSet.page || dataToSet.items || dataToSet.total)
                    let checkFilter = '';
                    if (dataToSet.resultFilter) {
                        checkFilter = String(dataToSet.resultFilter)
                        delete dataToSet.resultFilter;
                    }
                    let search = this.props[0].location.search;
                    let serachParams = getSearchParams(search);
                    let searchParamsFilter = '';
                    if (serachParams.filter) {
                        searchParamsFilter = serachParams.filter;
                    }
                    if (searchParamsFilter != checkFilter) {
                        delete dataToSet.page;
                        delete dataToSet.items;
                        delete dataToSet.total;
                        delete dataToSet.loading;
                    }
                }
                this.setState({
                    ...dataToSet
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }
    }

    checkDoctorsAvailable = (doctorsList, modal, callback) => {
        let event;


        if (modal == 1) {
            event = this.state.updateEvent;
        } else if (modal == 2) {
            event = this.state.scheduleReferral;
        } else if (modal == 3) {
            event = this.state.scheduleControl;
        } else if (modal == 4) {
            event = doctorsList;
            doctorsList = doctorsList.additionalDoctors;
        } else if (modal == 5) {
            event = this.state.scheduleListReferral;
        }
        // console.log(event)

        if (doctorsList) {
            let data = {
                doctorsList: doctorsList,
                startEventReservedDateOriginal: event.date + ' ' + event.startTime,
                endEventReservedDateOriginal: event.date + ' ' + event.endTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                eventId: event.id
            }
            fetch(API_ENDPOINT + '/working-hours/check/doctors', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        errorAdditionalDoctors: result.doctorsList
                    })
                } else {
                    this.setState({ doctorsModal: false, successfullyAdditionalDoctors: modal != 4 ? true : false }, () => {
                        if (modal == 1) {
                            let updateEvent = this.state.updateEvent;
                            updateEvent.additionalDoctors = this.state.doctorsList;
                            this.setState({ updateEvent })
                        } else if (modal == 2) {
                            let scheduleReferral = this.state.scheduleReferral;
                            scheduleReferral.additionalDoctors = this.state.doctorsList;
                            this.setState({ scheduleReferral })
                        } else if (modal == 3) {
                            let scheduleControl = this.state.scheduleControl;
                            scheduleControl.additionalDoctors = this.state.doctorsList;
                            this.setState({ scheduleControl })
                        } else if (modal == 5) {
                            let scheduleListReferral = this.state.scheduleListReferral;
                            scheduleListReferral.additionalDoctors = this.state.doctorsList;
                            this.setState({ scheduleListReferral })
                        }


                    })
                }
                if (callback) {
                    callback();
                }


            })
        }


    }

    generateSections = (itemsArr) => {
        let sections = {};
        let items = [{ type: 0 }, ...itemsArr];
        let lastSectionId = -1;
        for (let i = 0; i < items.length; i++) {
            if (items[i].type == 0) {
                lastSectionId++;
                sections[lastSectionId] = {
                    name: items[i].name,
                    displayOnReferral: false,
                    questions: [],
                    conditions: items[i].conditions ? items[i].conditions : [],
                    displayOnReferral: items[i].displayOnReferral,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,

                }
            }
            if (lastSectionId != -1 && items[i].type != 0) {


                let wikiLinks = [];

                items[i].wikiLinks = wikiLinks;


                if (items[i].type == 1) {
                    let displayOnReferral = false;
                    if (items[i].answers) {
                        for (let j = 0; j < items[i].answers.length; j++) {
                            if (items[i].answers[j].text) {
                                displayOnReferral = true;
                            }
                        }
                    }

                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        answers: items[i].answers,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        displayOnReferral: displayOnReferral,
                        wikiLinks: items[i].wikiLinks,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    });

                } else if (items[i].type == 2) {
                    let displayOnReferral = false;
                    if (items[i].answers) {
                        for (let j = 0; j < items[i].answers.length; j++) {

                            if (items[i].answers[j].text) {
                                displayOnReferral = true;
                            }
                        }
                    }
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        answers: items[i].answers,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        answerPrefix: items[i].answerPrefix,
                        userInput: items[i].userInput,
                        displayOnReferral: displayOnReferral || items[i].answerPrefix ? true : false,
                        wikiLinks: items[i].wikiLinks,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,

                    })
                } else if (items[i].type == 3) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        answerPrefix: items[i].answerPrefix,
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })

                } else if (items[i].type == 4) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        text: items[i].text,
                        userInput: items[i].userInput,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })
                } else if (items[i].type == 15) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        text: items[i].text,
                        userInput: items[i].userInput,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })

                } else if (items[i].type == 5) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        score: items[i].score
                    })

                } else if (items[i].type == 6) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        score: items[i].score
                    })

                } else if (items[i].type == 7) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })

                } else if (items[i].type == 8) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })

                } else if (items[i].type == 9) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })

                } else if (items[i].type == 10) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        userInput: items[i].userInput,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })
                } else if (items[i].type == 12) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        score: items[i].score
                    })
                } else if (items[i].type == 14) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        score: items[i].score
                    })

                } else if (items[i].type == 13) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        score: items[i].score
                    })

                } else if (items[i].type == 16) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        blocks: items[i].blocks,
                    })

                } else if (items[i].type == 17) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        blocks: items[i].blocks,

                    })

                }
            }
        }

        return Object.values(sections);
    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();


        this.interval = setInterval(() => {
            this.get();
        }, 60 * 1000);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }

        if (prevProps.selectedClinic != this.props.selectedClinic) {
            this.updateMultipleParams([{ name: 'page', value: '0' }, { name: 'entries', value: '10' }])
            this.get();
        }
        if (prevState.referral != this.state.referral && !this.state.referral && this.state.activeRevisitForm !== 1) {
            this.setState({ activeRevisitForm: 1 })
        }

        if (this.state.responseTimestamp && prevState.responseTimestamp && JSON.stringify(this.state.responseTimestamp) != JSON.stringify(prevState.responseTimestamp)) {
            this.setState({
                disableFilterButtons: false
            })
        }
    }

    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0, sortField: 'timestamp', sortType: -1 }, [{ name: 'sortField', value: field }, { name: 'sortType', value: type }], false));

        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0, sortField: 'timestamp', sortType: -1 }, name, value, restart));
        }
    }

    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0, sortField: 'timestamp', sortType: -1 }, fields, restart));
        }
    }

    closeReferral = (data, action = false) => {
        const closeCaseActionModal = {
            data: data ? JSON.parse(JSON.stringify(data)) : null,
            function: 'closeReferral'
        }
        if (!data) data = {};
        data.selectedGroup = this.props.selectedGroup;
        data.closeConversation = true;
        data.action = action;

        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/close/' + this.state.referral._id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result?.eventExits && result?.neededAction) {
                    this.setState({
                        closeCaseActionModal: closeCaseActionModal,
                        loading: false
                    })
                    return;
                }
                this.get();
                if (result?.error) {
                    this.setState({
                        error: result.error?.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    this.setState({
                        referral: null,
                        disallowForm: false,
                        returnForm: false,
                        scheduleForm: false
                    })
                }

            })
        })
    }
    deleteReferral = () => {
        if (!this.state.referral?._id) {
            return;
        }
        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/delete/' + this.state.referral._id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({})
            }).then(res => res.json()).then((result) => {
                this.get();
                if (result?.error) {
                    this.setState({
                        error: result.error?.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    this.setState({
                        referral: null,

                    })
                }

            })
        })
    }

    conversation = (id, data) => {
        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/conversation/recpient/' + id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                this.props[0].history.push(`/chat?conversation=${result.conversation}`)
            })

        })
    }

    transferReferral = (referral) => {
        if (this.state.loadingTransfer) return;
        let data = {};
        if (referral && referral.event && (referral.status == 'scheduled' || referral.status === 'visit-rescheduled')) {
            if (referral.event.date) {
                data.date = referral.event.date;
            }
            if (referral.event.startTimeString) {
                data.startTime = referral.event.startTimeString;
            }
            if (referral.event.endTimeString) {
                data.endTime = referral.event.endTimeString;
            }
            if (this.state.selectedDoctor) {
                data.doctor = this.state.selectedDoctor;
            }
            if (referral.event._id) {
                data.id = referral.event._id;
            }
            this.setState({
                loading: true,
                loadingTransfer: true
            }, () => {
                fetch(API_ENDPOINT + '/referrals/transfer/' + data.id, {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({ startEventReservedDateOriginal: data.date + ' ' + data.startTime, endEventReservedDateOriginal: data.date + ' ' + data.endTime, startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`), endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`), doctor: data.doctor, group: this.props.selectedGroup, clinic: this.props.selectedClinic })
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        if (result.error == 'Event can not start or end while others are in progress!') {
                            this.setState({
                                errorOverlap: {
                                    message: 'Unable to transfer this case to a new caregiver. The term is not available.'.translate(this.props.lang),
                                    doctor: referral.recipientUser,
                                    date: referral.event.startTime

                                },
                                loading: false,
                                loadingTransfer: false
                            })
                        } else {
                            this.setState({
                                error: result.error.translate(this.props.lang),
                                loading: false,
                                loadingTransfer: false
                            })
                        }
                    } else {
                        this.get()
                        this.setState({
                            transferModal: null,
                            selectedDoctor: -1,
                            loading: false,
                            loadingTransfer: false
                        })
                    }

                })
            })


        } else if (referral) {
            this.setState({
                loading: true,
                loadingTransfer: true
            }, () => {
                fetch(API_ENDPOINT + '/referrals/transfer/drop-in/' + referral._id, {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({ doctor: this.state.selectedDoctor, prevDoctor: referral.recipientUser, group: this.props.selectedGroup, clinic: this.props.selectedClinic, transferType: 'bookingByClinic' })
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error,
                            loading: false,
                            loadingTransfer: false
                        })
                    } else {
                        this.get();

                        this.setState({
                            transferModal: false,
                            selectedDoctor: -1,
                            loading: false,
                            loadingTransfer: false

                        })
                    }
                })
            })

        }

    }

    generateTimeReferral = async (data) => {
        if (data?.event?.patientControlNote) {
            data.patientNote = data.event.patientControlNote;
        }
        let date = new Date();
        var startDate = this.props.getStringDateTs(Math.floor(date.getTime() / 1000), 'YYYY-MM-DD')/*moment.unix(Math.floor(date.getTime() / 1000)).format('YYYY-MM-DD')*/;
        let start = this.props.getStringDateTs(Math.floor(date.getTime() / 1000 + 600), 'HH:mm')/*moment.unix(Math.floor(date.getTime() / 1000 + 600)).format('HH:mm')*/
        var end = this.props.getStringDateTs(Math.floor(date.getTime() / 1000 + 900), 'HH:mm')/*moment.unix(Math.floor(date.getTime() / 1000 + 900)).format("HH:mm")*/;


        data.date = startDate;
        data.startTime = start;
        data.endTime = end;
        if (!this.state.adminPermission) {

            this.setState({ listDoctor: this.props.uData._id, loadingDoctor: true, scroll: false }, () => {

                this.getWorkingTime(this.state.listDoctor)
            })
        }
        // let patientSSN = data?.patient?.socialSecurityNumber;
        // if (patientSSN) {
        //     let patientNotes = await this.checkPatientNotes(patientSSN);
        //     if (patientNotes && patientNotes.length) {
        //         data.patientNotes = patientNotes;
        //     }
        // }
        let referralId = data?._id;
        if (referralId) {
            let patientNotes = await this.checkPatientNotes(referralId);
            if (patientNotes && patientNotes.length) {
                data.patientNotes = patientNotes;
            }
        }
        // console.log(data)
        data = await checkRescheduleData(data, this.props)

        let setObj = {
            scheduleListReferral: data
        }
        if (data?.rescheduledData?.doctorId && this.state.subAccounts?.find(el => el._id === data?.rescheduledData?.doctorId) && this.state.adminPermission) {
            setObj.listDoctor = data?.rescheduledData?.doctorId;
        }
        this.setState(setObj, () => {
            if (setObj.listDoctor && this.state.listDoctor) {
                this.getWorkingTime(this.state.listDoctor);
            }
        })
    }

    getWorkingTime = () => {
        // {
        //     this.state.listDoctor ?
        //         this.state.subAccounts.filter(item => item._id.toString() == this.state.listDoctor).map(item => {
        //             if (item.workingTimeConfig) {
        //                 if (item.workingTimeConfig[this.props.selectedGroup] && item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic]) {
        //                     this.setState({
        //                         min: new Date(item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].min),
        //                         max: new Date(item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].max),

        //                     })
        //                 }
        //             }
        //         })
        //         : this.setState({
        //             min: this.state.min,
        //             max: this.state.max,
        //         })
        // }
        let obj = {

        };
        obj.min = new Date();
        obj.min.setHours(7, 0, 0)
        obj.max = new Date();
        obj.max.setHours(18, 0, 0)

        obj.min = new Date(this.props.getStringDateTs(Math.floor(new Date(obj.min).getTime() / 1000), 'MM/DD/YYYY HH:mm'))
        obj.max = new Date(this.props.getStringDateTs(Math.floor(new Date(obj.max).getTime() / 1000), 'MM/DD/YYYY HH:mm'))

        if (this.state.listDoctor) {
            if (this.state.subAccounts && this.state.subAccounts.length && this.state.subAccounts.filter(item => item._id.toString() == this.state.listDoctor).length) {
                let doctors = this.state.subAccounts.filter(item => item._id.toString() == this.state.listDoctor);
                for (let i = 0; i < doctors.length; i++) {
                    if (doctors[i].workingTimeConfig) {
                        if (doctors[i].workingTimeConfig[this.props.selectedGroup] && doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic]) {
                            obj.min = new Date(doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].min)
                            obj.max = new Date(doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].max)
                        }
                    }
                }
            }
        }
        let scheduleListReferral = this.state.scheduleListReferral;
        let min = this.props.getStringDateTs(Math.floor(obj.min.getTime() / 1000), 'HH:mm');
        let max = this.props.getStringDateTs(Math.floor(obj.max.getTime() / 1000), 'HH:mm');
        if (scheduleListReferral?.startTime && scheduleListReferral?.endTime && min) {
            let minSeconds = Number(min?.split(':')?.[0]) * 60 + Number(min?.split(':')?.[1])
            let maxSeconds = Number(max?.split(':')?.[0]) * 60 + Number(max?.split(':')?.[1])
            let startTimeSeconds = Number(scheduleListReferral.startTime?.split(':')?.[0]) * 60 + Number(scheduleListReferral.startTime?.split(':')?.[1])
            let endTimeSeconds = Number(scheduleListReferral.endTime?.split(':')?.[0]) * 60 + Number(scheduleListReferral.endTime?.split(':')?.[1])
            if (minSeconds > startTimeSeconds) {
                scheduleListReferral.startTime = min;
                obj.scheduleListReferral = scheduleListReferral;
            }
            if (minSeconds > endTimeSeconds) {
                scheduleListReferral.endTime = this.props.getStringDateTs(Math.floor((obj.min.getTime() / 1000) + 60 * 5), 'HH:mm');
                obj.scheduleListReferral = scheduleListReferral;
            }
            if (maxSeconds < startTimeSeconds) {
                scheduleListReferral.startTime = this.props.getStringDateTs(Math.floor((obj.max.getTime() / 1000) - 60 * 5), 'HH:mm');;
                obj.scheduleListReferral = scheduleListReferral;
            }
            if (maxSeconds < endTimeSeconds) {
                scheduleListReferral.endTime = max;
                obj.scheduleListReferral = scheduleListReferral;
            }
        }
        this.setState(obj)

    }

    listScheduleReferral = (data) => {
        if (data && data.additionalDoctors && data.additionalDoctors.length) {

            this.checkDoctorsAvailable(data.additionalDoctors, 5, () => {
                if (!this.state.errorAdditionalDoctors) {
                    let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
                    let today = new Date();

                    if (checkDate >= today) {
                        // alert('test')
                        this.setState({
                            loading: true
                        }, () => {
                            fetch(API_ENDPOINT + '/referrals/schedule/' + data._id, {
                                method: 'POST',
                                headers: {
                                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                    'content-type': 'application/json'
                                },
                                body: JSON.stringify({
                                    startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                                    endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                                    startPatientReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                                    endPatientReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                                    doctor: this.state.listDoctor,
                                    patientNote: data.patientNote,
                                    additionalDoctors: data.additionalDoctors,
                                    rescheduleReferral: data.rescheduleReferral ? true : false,
                                    hideDurationForPatient: data.hideDurationForPatient
                                })
                            }).then(res => res.json()).then((result) => {
                                // alert('test')
                                if (result.error) {
                                    if (result.error == 'Event can not start or end while others are in progress!') {
                                        this.setState({
                                            errorOverlap: {
                                                message: 'Unable to schedule this case. Selected time period is not available.'.translate(this.props.lang),
                                                doctor: this.state.listDoctor,
                                                date: Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000)

                                            },
                                            loading: false
                                        })
                                    } else {
                                        this.setState({
                                            error: result.error.translate(this.props.lang),
                                            loading: false
                                        })
                                        this.get();
                                    }
                                } else {
                                    this.get();
                                    this.setState({
                                        scheduleListReferral: null,
                                        doctor: this.state.listDoctor,
                                        doctorsList: [],
                                        referral: null,
                                        listDoctor: null
                                    }, () => {
                                        // this.setState({
                                        //     day: new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime),
                                        //     view: 'day',
                                        //     scroll: true,
                                        // }, () => {
                                        //     this.get();
                                        //     this.getWorkingTime()
                                        // })
                                    })
                                }

                            })
                        })
                    } else {
                        this.setState({
                            wrongDate: true
                        })


                    }
                }

            })
        } else {
            let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
            let today = new Date();

            if (checkDate >= today) {
                // alert('test')
                this.setState({
                    loading: true
                }, () => {
                    fetch(API_ENDPOINT + '/referrals/schedule/' + data._id, {
                        method: 'POST',
                        headers: {
                            'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                            endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                            startPatientReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                            endPatientReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                            doctor: this.state.listDoctor,
                            patientNote: data.patientNote,
                            additionalDoctors: data.additionalDoctors,
                            rescheduleReferral: data.rescheduleReferral ? true : false,
                            hideDurationForPatient: data.hideDurationForPatient
                        })
                    }).then(res => res.json()).then((result) => {
                        // alert('test')
                        if (result.error) {
                            if (result.error == 'Event can not start or end while others are in progress!') {
                                this.setState({
                                    errorOverlap: {
                                        message: 'Unable to schedule this case. Selected time period is not available.'.translate(this.props.lang),
                                        doctor: this.state.listDoctor,
                                        date: Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000)

                                    },
                                    loading: false
                                })
                            } else {
                                this.setState({
                                    error: result.error.translate(this.props.lang),
                                    loading: false
                                })
                                this.get();
                            }
                        } else {
                            this.get();
                            this.setState({
                                scheduleListReferral: null,
                                doctor: this.state.listDoctor,
                                doctorsList: [],
                                referral: null,
                                listDoctor: null
                            }, () => {
                                // this.setState({
                                //     day: new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime),
                                //     view: 'day',
                                //     scroll: true,
                                // }, () => {
                                //     this.get();
                                //     this.getWorkingTime()
                                // })
                            })
                        }

                    })
                })
            } else {
                this.setState({
                    wrongDate: true
                })


            }
        }


    }

    generateHtmlForPrint = () => {
        let referral = this.state.referral;
        let html = '<div>';
        if (referral) {
            html += `${this.props.lang == 'se' ? this.state.referral.referralContent : this.state.referral.referralContentEn ? this.state.referral.referralContentEn : this.state.referral.referralContent}`
            if (referral.revisitFormsArray && referral.revisitFormsArray.length) {
                let revisitFormsArray = referral.revisitFormsArray;
                for (let i = 0; i < revisitFormsArray.length; i++) {
                    html += `<h6 style="font-size: 18px;">${'Patient answers'.translate(this.props.lang)} <span style="margin-left:20px; font-weight:600">${revisitFormsArray[i].name}</span> </h6>`
                    if (revisitFormsArray[i].referralData) {
                        html += `${revisitFormsArray[i].referralData ? revisitFormsArray[i].referralData : ''}`
                        html += `${revisitFormsArray[i].referralTotalData ? revisitFormsArray[i].referralTotalData : ''}`
                    } else {
                        html += `<p style="font-style: italic; font-size: 14px;">${'The patient did not fill out the form'.translate(this.props.lang)}</p>`
                    }
                    if (i != (revisitFormsArray.length - 1)) {
                        html += '<hr/>'
                    }
                }
            }

        }
        html += '</div>'

        return html;
    }

    getPatientProfile = (item) => {


        fetch(API_ENDPOINT + '/users/referral/patient-profile', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ referral: item._id })
        }).then(res => res.json()).then((result) => {
            if (result && result.patient) {
                let obj = { ...item, ...result }
                this.setState({ patientProfile: obj })
            } else {
                this.setState({ patientProfile: item })
            }
        })
    }

    searchPatientWithRedirect = (SSN, enterprise) => {
        let obj = {
            socialSecurityNumber: SSN,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic,
        }
        enterprise && (obj.openOnWebDoc = true);

        fetch(API_ENDPOINT + '/users/find/patient', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(res => res.json()).then((result) => {
            //result = result?.error ? result?.error : result?.length ? result[0] : null;
            if (result && result._id) {
                const path = enterprise ? '/patients/search-enterprise' : '/patients/search';
                this.props.registerClinicGroupLogs({
                    type: 'patientProfile',
                    patient: SSN,
                });

                let state = {
                    TYPE: 'redirect',
                    redirectPatient: result,
                    redirectTabIndex: 1
                }
                enterprise && (state.redirectTabActive = 1);

                this.props[0].history.push(path, state);

            } else {
                this.setState({ error: 'User not found in this clinic group' })
            }
        })
    }

    prepareNote = (item) => {
        let counter = 0
        let noteArr = item.note.split('')
        let noteFinished = ''
        for (let i = 0; i < noteArr.length; i++) {
            counter++
            noteFinished = noteFinished + noteArr[i]
            if (noteArr[i] === '\n') {
                counter = 0
            }

            if (counter === 80) {
                counter = 0
                noteFinished = noteFinished + '\n'
            }

        }

        item.note = noteFinished

        return item.note.split('\n').join('<br/>')
    }

    updateReferralNote = (data) => {
        let obj = {
            note: data.note,
            username: this.props.uData.username
        }
        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/note/' + data._id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(obj)
            }).then(res => res.json()).then((result) => {
                this.setState({
                    referralNote: null,

                })
                this.get()
            })
        })
    }

    removeReferralFromList = (referralId) => {
        let data = {
            referralId: referralId,
            clinic: this.props.selectedClinic
        }
        if (data.referralId && data.clinic) {
            fetch(API_ENDPOINT + '/referral/remove/transfered/info', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result?.error) {
                    this.setState({ error: result.error })
                } else {
                    this.setState({ removeReferralModal: null, referral: null })
                    this.get()

                }

            })
        }


    }
    openNotes = async (item) => {
        if (!item) return;
        let patientSSN, referralId;
        if (item?.patient?.socialSecurityNumber) patientSSN = item.patient.socialSecurityNumber;
        if (item?._id) referralId = item._id;
        let patientNotes = await this.checkPatientNotes(referralId);

        let _item = JSON.parse(JSON.stringify(item));
        if (patientNotes) {
            _item.patientNotes = patientNotes;
        }

        this.setState({ referralNote: { ..._item, note: '' }, patientNotesReferralId: referralId })
    }
    checkPatientNotes = async (referralId) => {

        if (!referralId) {
            return [];
        }
        let data = {
            referralId,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup,
            lang: this.props.lang
        };
        let result = await fetch(API_ENDPOINT + `/user/patients-notes/fetch`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        try {
            let response = await result.json();
            if (response?.items?.length) {
                return response.items;
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching patient notes:', error);
            return [];

        }
    }

    render() {

        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0, sortField: 'timestamp', sortType: -1 })
        }


        let subgroups = [{ name: 'None', value: null }];

        if (this.props.group) {
            for (let i = 0; i < this.state.subgroups.length; i++) {
                if (this.state.subgroups[i].groups && this.state.subgroups[i].groups.indexOf(this.props.group) !== -1) {
                    subgroups.push(this.state.subgroups[i]);
                }
            }
        }

        const statusColors = {
            'waiting-for-approval': 'orange',
            'waiting-for-payment': 'orange',
            'disallowed': 'red',
            'allowed': 'green',
            'return-for-update': 'blue',
            'patient-requested-another-time': 'purple',
            'patient-rejected': 'red',
            'patient-accepted': 'green',
            'clinic-accepted-requested-time': 'green',
            'clinic-rejected-requested-time': 'orange',
            'approved-by-region-manager': 'green',
            'rejected-by-region-manager': 'red',
            'scheduled': 'green',
            'visit-rescheduled': 'green',
            'revisit-scheduled': 'green',
            'not-booked': 'red',
            'closed': 'gray',
            'canceled-by-clinic': 'red',
            'requested-new-appointment': 'orange',
            'external': 'gray',
            'not-scheduled': 'red',


        }

        const humanReadable = {
            'waiting-for-approval': 'Waiting for approval'.translate(this.props.lang),
            'waiting-for-payment': 'Waiting for payment'.translate(this.props.lang),
            'disallowed': 'Disallowed'.translate(this.props.lang),
            'allowed': 'Allowed'.translate(this.props.lang),
            'return-for-update': 'Return for update'.translate(this.props.lang),
            'patient-requested-another-time': 'Patient requested anoother time'.translate(this.props.lang),
            'patient-rejected': 'Cancelled by patient'.translate(this.props.lang), //  'Rejected by patient'.translate(this.props.lang),
            'patient-accepted': 'Patient accepted'.translate(this.props.lang),
            'clinic-accepted-requested-time': 'Clinic accepted requested time'.translate(this.props.lang),
            'clinic-rejected-requested-time': 'Clinic rejected requested time'.translate(this.props.lang),
            'approved-by-region-manager': 'Approved by region manager'.translate(this.props.lang),
            'rejected-by-region-manager': 'Rejected by region manager'.translate(this.props.lang),
            'scheduled': 'Scheduled'.translate(this.props.lang),
            'visit-rescheduled': 'Visit rescheduled'.translate(this.props.lang),
            'revisit-scheduled': 'Revisit scheduled'.translate(this.props.lang),
            'not-booked': 'Cancelled by clinician'.translate(this.props.lang), //'Not booked'.translate(this.props.lang),
            'closed': 'Closed'.translate(this.props.lang),
            'canceled-by-clinic': 'Cancelled by clinician'.translate(this.props.lang), // 'Canceled by clinic'.translate(this.props.lang),
            'requested-new-appointment': 'Requested new appointment'.translate(this.props.lang),
            'external': 'External transfer'.translate(this.props.lang),
            'not-scheduled': 'Not scheduled'.translate(this.props.lang),
        }

        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let enterprise = this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].enterprise;
        let canSearchPatients = this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].sarchPatients;

        const groupPermissionsUser = this.props.uData?.groupPermissionsUser;
        const adminPermissionId = this.props.uData?.permissions?.admin;
        const doctorPermissionId = this.props.uData?.permissions?.doctor;
        const schedulerPermissionId = this.props.uData?.permissions?.scheduler;

        const isAdmin = groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(adminPermissionId) !== -1 || groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(schedulerPermissionId) !== -1 ? true : false;
        const isDoctor = groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(doctorPermissionId) !== -1 ? true : false;

        const eConnectEnabled = this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].eConnect && !this.props.uData.clinicGroups[selectedGroupIdx].eConnectTempDisabled;

        // if (!this.props.showExternalBookings) {
        //     this.props[0].history.push('/my-data/account')
        //     return null;
        // }


        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <div className="panel">
                                <h5 className="component-header">{this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}</h5>
                                {window.location.href == `${window.location.origin}/my-data/personal-referrals/closed` ? null :
                                    <div >
                                        <div style={{ marginTop: 10 }}>
                                            <Label>{'Case status:'.translate(this.props.lang)}</Label>
                                        </div>


                                        <div className="profession-buttons mr-0">

                                            <div>
                                                <div >
                                                    <button disabled={this.state.disableFilterButtons} className={this.state.scheduled ? ' clicked' : ''} onClick={() => {
                                                        this.setState({
                                                            scheduled: !this.state.scheduled,
                                                            // waitingForApproval: false,
                                                            // waitingForPayment: false,
                                                            // allowed: false,
                                                            // notBooked: false,
                                                            // rejectedByPatient: false,
                                                            // closed: false
                                                            disableFilterButtons: true
                                                        }, () => this.get(), this.updateMultipleParams([{ name: 'page', value: '0' }, { name: 'entries', value: '10' }]))
                                                    }} >{'Scheduled'.translate(this.props.lang)}</button>
                                                </div>
                                            </div>

                                            <div>
                                                <div >
                                                    <button disabled={this.state.disableFilterButtons} className={this.state.notBooked ? ' clicked' : ''} onClick={() => {
                                                        this.setState({
                                                            notBooked: !this.state.notBooked,
                                                            // waitingForApproval: false,
                                                            // waitingForPayment: false,
                                                            // allowed: false,
                                                            // scheduled: false,
                                                            // rejectedByPatient: false,
                                                            // closed: false
                                                            disableFilterButtons: true
                                                        }, () => this.get(), this.updateMultipleParams([{ name: 'page', value: '0' }, { name: 'entries', value: '10' }]))
                                                    }} >{'Cancelled by clinic'.translate(this.props.lang)}</button>
                                                </div>
                                            </div>

                                            <div>
                                                <div >
                                                    <button disabled={this.state.disableFilterButtons} className={this.state.requestedNewAppointment ? ' clicked' : ''} onClick={() => {
                                                        this.setState({
                                                            requestedNewAppointment: !this.state.requestedNewAppointment,
                                                            // waitingForApproval: false,
                                                            // waitingForPayment: false,
                                                            // allowed: false,
                                                            // scheduled: false,
                                                            // rejectedByPatient: false,
                                                            // closed: false
                                                            disableFilterButtons: true
                                                        }, () => this.get(), this.updateMultipleParams([{ name: 'page', value: '0' }, { name: 'entries', value: '10' }]))
                                                    }} >{'Requested new appointment'.translate(this.props.lang)}</button>
                                                </div>
                                            </div>

                                            <div>
                                                <div >
                                                    <button disabled={this.state.disableFilterButtons} className={this.state.rejectedByPatient ? ' clicked' : ''} onClick={() => {
                                                        this.setState({
                                                            rejectedByPatient: !this.state.rejectedByPatient,
                                                            // waitingForApproval: false,
                                                            // waitingForPayment: false,
                                                            // allowed: false,
                                                            // scheduled: false,
                                                            // notBooked: false,
                                                            // closed: false
                                                            disableFilterButtons: true
                                                        }, () => this.get(), this.updateMultipleParams([{ name: 'page', value: '0' }, { name: 'entries', value: '10' }]))
                                                    }} >{'Cancelled by patient'.translate(this.props.lang)}</button>
                                                </div>
                                            </div>

                                            <div>
                                                <div >
                                                    <button disabled={this.state.disableFilterButtons} className={this.state.closed ? ' clicked' : ''} onClick={() => {
                                                        this.setState({
                                                            closed: !this.state.closed,
                                                            // waitingForApproval: false,
                                                            // waitingForPayment: false,
                                                            // allowed: false,
                                                            // scheduled: false,
                                                            // notBooked: false,
                                                            // rejectedByPatient: false
                                                            disableFilterButtons: true
                                                        }, () => this.get(), this.updateMultipleParams([{ name: 'page', value: '0' }, { name: 'entries', value: '10' }]))
                                                    }} >{'Closed'.translate(this.props.lang)}</button>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                }
                                <div style={{ marginBottom: 20 }}>

                                </div>
                                <ListBuilder
                                    lang={this.props.lang}
                                    loading={this.state.loading}
                                    total={this.state.total}
                                    showNumeration={false}
                                    columnVisibility={this.props[0].location.pathname == '/my-data/personal-referrals/closed' ? 'history' : 'booking-by-clinic'} //columnVisibility
                                    uData={this.props.uData} //columnVisibility
                                    updateListBuilderFields={this.props.updateListBuilderFields} //columnVisibility
                                    get={this.get}//columnVisibility
                                    fields={[
                                        { type: 'text', name: 'recpientClinicName', label: 'Recipient'.translate(this.props.lang), allowSort: true },
                                        { type: 'text', name: 'remissType', label: 'Referral Type'.translate(this.props.lang), allowSort: true },
                                        { type: 'text', name: 'source', label: 'Source'.translate(this.props.lang), allowSort: true },
                                        { type: 'text', name: 'patient', label: 'Patient'.translate(this.props.lang), allowSort: false },
                                        { type: 'text', name: 'version', label: 'Referral ID'.translate(this.props.lang), allowSort: true },
                                        { type: 'text', name: 'questionaryName', label: 'Visit reason'.translate(this.props.lang), allowSort: true },
                                        { type: 'text', name: 'patientReservedTimestamp', label: 'Visit date'.translate(this.props.lang), allowSort: true },
                                        { type: 'text', name: 'status', label: 'Status'.translate(this.props.lang), allowSort: true },

                                        { type: 'text', name: 'timestamp', label: 'Created'.translate(this.props.lang), allowSort: true },

                                        { type: 'text', name: 'lastActivity', label: 'Last activity'.translate(this.props.lang), allowSort: true },



                                    ]}
                                    rawItems={this.state.items}
                                    items={this.state.items.map((item => {
                                        return {
                                            ...item,
                                            profession: this.props.lang == 'en' ? item.professionNameEn : item.professionNameSv,
                                            remissType: item.remissTypeEn ? item.remissTypeEn.translate(this.props.lang) : '',
                                            questionaryName: item?.source === 'Semble' ? `Semble - ${item?.sembleBooking?.appointment?.title ?? 'N/A'}` : 'N/A' /*this.props.lang == 'en' ? item.questionaryName?.replace?.(' (onlinebesök)', ' (online visit)') : item.questionaryName?.replace?.(' (online visit)', ' (onlinebesök)')*/,
                                            version: item.patient?.referralNumber + (item.version != 0 ? '.' + item.version : ''),
                                            recpientClinicName: <>{item.recpientClinicName}<br /><span className="clinic-subgroup-name">{item.recpientClinicSubgroupName} </span><br /> <span className="clinic-subgroup-name">{item.doctorName}</span>  </>,
                                            patient: <Button color='#fff' className="patient-modal-button" onClick={() => {
                                                // this.setState({ patientProfile: item }, () => {
                                                //     this.props.registerClinicGroupLogs({
                                                //         type: 'patientProfile',
                                                //         patient: item.patient?.socialSecurityNumber
                                                //     })
                                                // })
                                                if (enterprise || canSearchPatients) {
                                                    this.searchPatientWithRedirect(item.patient?.socialSecurityNumber, enterprise);
                                                } else {
                                                    this.getPatientProfile(item)
                                                    this.props.registerClinicGroupLogs({
                                                        type: 'patientProfile',
                                                        patient: item.patient?.socialSecurityNumber
                                                    })
                                                }

                                            }}>{item.patient?.name}<br /><span className="clinic-subgroup-name">{item.patient?.socialSecurityNumber} </span> {item?._2fa ? <p style={{ padding: 0, margin: 0, color: 'red', fontSize: 12 }}>{'2FA'.translate(this.props.lang)}</p> : null} </Button>,
                                            timestamp: this.props.getStringDateTs(item.timestamp, `${this.props.dateFormat} HH:mm`)/*moment.unix(item.timestamp).format(`${this.props.dateFormat} HH:mm`)*/,
                                            lastActivity: item.tsModified ? this.props.getStringDateTs(item.tsModified, `${this.props.dateFormat} HH:mm`)/*moment.unix(item.tsModified).format(`${this.props.dateFormat} HH:mm`)*/ : this.props.getStringDateTs(item.tsCreated, `${this.props.dateFormat} HH:mm`)/*moment.unix(item.tsCreated).format(`${this.props.dateFormat} HH:mm`)*/,
                                            converateTimestamp: this.props.getStringDateTs(item.converateTimestamp, `${this.props.dateFormat} HH:mm`)/*moment.unix(item.converateTimestamp).format(`${this.props.dateFormat} HH:mm`)*/,
                                            statusValue: item.status,
                                            patientReservedTimestamp: item.patientReservedTimestamp ? this.props.getStringDateTs(item.patientReservedTimestamp, `${this.props.dateFormat} HH:mm`)/*moment.unix(item.patientReservedTimestamp).format(`${this.props.dateFormat} HH:mm`)*/ : 'N/A',
                                            status: item.recipientClinic !== this.props.selectedClinic ? <>
                                                <span style={{ color: statusColors['external'] }}>{humanReadable['external']} </span><br />


                                            </> :
                                                <>
                                                    <span style={{ color: statusColors[item.status] }}>{humanReadable[item.status]} </span><br />


                                                </>,

                                        }
                                    }))}
                                    actions={
                                        [
                                            {
                                                component: <div className="tabel-action-tooltip"> <Isvg src={viewIcon} /> <div className="chat-icons-tooltip">{'Preview'.translate(this.props.lang)}</div> </div>,
                                                onClick: (item) => {
                                                    fetch(API_ENDPOINT + '/notification/seen/update-type', {
                                                        method: 'POST',
                                                        headers: {
                                                            'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                                            'content-type': 'application/json'
                                                        },
                                                        body: JSON.stringify({ type: item._id, user: this.props.uData._id })
                                                    }).then(res => res.json()).then((result) => {
                                                        this.props.verifyUser()
                                                        this.setState({ referral: item })
                                                    })
                                                }
                                            },
                                            // {
                                            //     component: <div className="tabel-action-tooltip">  test <div className="chat-icons-tooltip">{'Preview'.translate(this.props.lang)}</div> </div>,
                                            //     onClick: (item) => this.setState({ referralContentPreview: item }, () => {
                                            //         this.setState({ refresh: new Date().getTime() })
                                            //     })
                                            // },
                                            {
                                                component: <div className="tabel-action-tooltip"> <Isvg src={ChatIcon} /> <div className="chat-icons-tooltip">{'Start conversation'.translate(this.props.lang)}</div> </div>,
                                                onClick: async (item) => {

                                                    if (item && item.patient && item.patient?.socialSecurityNumber == this.props.uData.socialSecurityNumber) {
                                                        this.setState({ messageInfo: 'Unable to open a new conversation. Both participants are using the same account.'.translate(this.props.lang) })
                                                        return;
                                                    }
                                                    if (item.conversations && item.conversations.length) {
                                                        if (this.props._openConversationFunction) await this.props._openConversationFunction(item?.conversations?.[0]?._id, item?._id);
                                                        if (item.conversations[0].members && item.conversations[0].members.filter(el => el == this.props.uData._id).length) {
                                                            this.props[0].history.push(`/chat?conversation=${item.conversations[0]._id}`)
                                                        } else {
                                                            this.addUserToConversation(item.conversations[0]._id)
                                                        }

                                                    } else {
                                                        this.setState({
                                                            conversationForm: { name: item.patient?.referralNumber + '-' + pad(item.conversations.length + 1, 2) }
                                                        }, () => {
                                                            this.conversation(item._id, { ...this.state.conversationForm, patient: true });

                                                        })
                                                    }
                                                },
                                                condition: (item) => {
                                                    if (item.recipientClinic !== this.props.selectedClinic) {
                                                        return false;
                                                    } else if ((item.statusValue == 'waiting-for-approval' || item.statusValue == 'waiting-for-payment') && item.conversations && item.conversations.length) {
                                                        return false
                                                    } else {
                                                        return true;
                                                    }

                                                }
                                            },
                                            {
                                                renderComponent: (item) => {
                                                    return (
                                                        <div className="tabel-action-tooltip inverse-chat-icon">
                                                            <Isvg src={ChatIcon2} />
                                                            {
                                                                item.conversations && item.conversations[0] && item.conversations[0].startedByUser ?
                                                                    <div className="chat-icons-tooltip">
                                                                        {item.conversations[0].startedByUser} {"has started the conversation. Click to open.".translate(this.props.lang)}
                                                                    </div>
                                                                    :
                                                                    null
                                                            }

                                                        </div>)
                                                },
                                                onClick: async (item) => {
                                                    // console.log(item && item.conversations && item.conversations[0])

                                                    if (item && item.patient && item.patient?.socialSecurityNumber == this.props.uData.socialSecurityNumber) {
                                                        this.setState({ messageInfo: 'Unable to open a new conversation. Both participants are using the same account.'.translate(this.props.lang) })
                                                        return;
                                                    }
                                                    if (item.conversations && item.conversations.length) {
                                                        if (this.props._openConversationFunction) await this.props._openConversationFunction(item?.conversations?.[0]?._id, item?._id);
                                                        if (item.conversations[0].members && item.conversations[0].members.filter(el => el == this.props.uData._id).length) {
                                                            this.props[0].history.push(`/chat?conversation=${item.conversations[0]._id}`)
                                                        } else {
                                                            this.addUserToConversation(item.conversations[0]._id)
                                                        }

                                                    } else {
                                                        this.setState({
                                                            conversationForm: { name: item.patient?.referralNumber + '-' + pad(item.conversations.length + 1, 2) }
                                                        }, () => {
                                                            this.conversation(item._id, { ...this.state.conversationForm, patient: true });

                                                        })
                                                    }
                                                },
                                                condition: (item) => {
                                                    if (item.recipientClinic !== this.props.selectedClinic) {
                                                        return false;
                                                    } else if ((item.statusValue == 'waiting-for-approval' || item.statusValue == 'waiting-for-payment') && item.conversations && item.conversations.length) {
                                                        return true
                                                    } else {
                                                        return false;
                                                    }

                                                }
                                            },


                                            /*{
                                                component: <i className="fa fa-undo base-color" />,
                                                onClick: (item) => this.setState({ form: item })
                                            },

                                            {
                                                component: <i className="fa fa-ban danger-color" />,
                                                onClick: (item) => this.setState({ form: item })
                                            },*/
                                            {
                                                renderComponent: (item) => <div className="tabel-action-tooltip"> <Isvg src={transferIcon} className={eConnectEnabled && item?._consultation ? "transfer-icon consultation-active-icon" : "transfer-icon"} /> <div className="chat-icons-tooltip">{eConnectEnabled ? 'Consultation'.translate(this.props.lang) : 'Transfer'.translate(this.props.lang)}</div> </div>,
                                                onClick: async (item) => {
                                                    if (eConnectEnabled && this.props.checkIfConsultationExists && item?._id) {
                                                        let consultationExists = await this.props.checkIfConsultationExists(item._id, () => {
                                                            this.setState({ transferModal: item })
                                                        });
                                                        if (!consultationExists)
                                                            this.setState({ transferModal: item })
                                                    } else {
                                                        this.setState({ transferModal: item })
                                                    }

                                                },
                                                condition: (item) => {
                                                    if (item.recipientClinic !== this.props.selectedClinic) {
                                                        return false;
                                                    } else if ((item.statusValue == 'allowed' || item.statusValue == 'scheduled' || item.statusValue === 'visit-rescheduled' || item.statusValue == 'not-booked') && this.state.adminPermission)
                                                        return true;
                                                    else
                                                        return false;
                                                }
                                            },
                                            {
                                                component: <div className="tabel-action-tooltip" style={{ width: 24, height: 22 }}>
                                                    <Isvg src={historyIcon} />
                                                    <div className="chat-icons-tooltip">{'View history'.translate(this.props.lang)}</div>
                                                </div>,
                                                condition: showStatusHistoryButton,
                                                onClick: item => this.setState({ statusHistoryModal: item })
                                            },
                                            enterprise ?
                                                {
                                                    renderComponent: (item) => {
                                                        return (
                                                            <div className="tabel-action-tooltip">
                                                                <Isvg src={infoIcon} className={item && item.note ? "note-icon" : ''} style={{ width: 36, height: 23 }} />
                                                                <div className="chat-icons-tooltip info-tooltip-custom"><span>
                                                                    {
                                                                        item && item.note && false ?
                                                                            <div dangerouslySetInnerHTML={{ __html: this.prepareNote(item) }}></div> :
                                                                            'Note'.translate(this.props.lang)
                                                                    }
                                                                    {/* {item && item.note && item.noteUsername ? ' ' + item.noteUsername : ''}<br />{item && item.note && item.noteUsername && item.noteTimestamp ? ' ' + this.props.getStringDateTs(item.noteTimestamp, `${this.props.dateFormat} HH:mm`) : ''} */}
                                                                </span></div>
                                                            </div>
                                                        )
                                                    },
                                                    onClick: (item) => this.openNotes(item),
                                                    condition: (item) => {
                                                        if (item.recipientClinic === this.props.selectedClinic)
                                                            return true;
                                                        else
                                                            return false;
                                                    }
                                                } : {
                                                    renderComponent: () => { return null },
                                                    onClick: () => { },
                                                    condition: (item) => {
                                                        if (item.recipientClinic === this.props.selectedClinic)
                                                            return true;
                                                        else
                                                            return false;
                                                    }
                                                },
                                            {
                                                component: <div className="tabel-action-tooltip"> <Isvg src={garbageIcon} className="transfer-icon" /> <div className="chat-icons-tooltip">{'Remove'.translate(this.props.lang)}</div> </div>,
                                                onClick: (item) => this.setState({ removeReferralModal: { ...item } }),
                                                condition: (item) => {
                                                    if (item.recipientClinic !== this.props.selectedClinic && isAdmin)
                                                        return true;
                                                    else
                                                        return false;
                                                }
                                            }
                                        ]
                                    }
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}

                                ></ListBuilder>
                                <DeleteModal
                                    lang={this.props.lang}
                                    isOpen={this.state.deleteModal}
                                    toggle={() => this.setState({ deleteModal: null })}
                                    handler={() => { this.delete(this.state.deleteModal._id); this.setState({ deleteModal: null }) }}
                                >
                                    {'Delete referral'.translate(this.props.lang)} <strong>{this.state.deleteModal && this.state.deleteModal.title}</strong>?
                                </DeleteModal>

                            </div>
                        </Col>
                    </Row>
                </Container>

                {
                    this.state.statusHistoryModal ? <ReferralStatusHistoryModal
                        isOpen={this.state.statusHistoryModal}
                        currency={this.props.currency}
                        onClose={() => this.setState({ statusHistoryModal: null })}
                        history={this.state.statusHistoryModal._id}
                        lang={this.props.lang}
                        country={this.props.country}
                        getStringDateTs={this.props.getStringDateTs}
                    /> : null
                }

                {
                    this.state.removeReferralModal ?
                        <DeleteModal
                            zIndex={99999}
                            lang={this.props.lang}
                            isOpen={this.state.removeReferralModal}
                            toggle={() => this.setState({ removeReferralModal: null })}
                            handler={() => { this.removeReferralFromList(this.state.removeReferralModal._id); }}
                        >
                            {'Do you want to delete the referral from the list of this clinic?'.translate(this.props.lang)}
                        </DeleteModal>
                        :
                        null
                }
                {
                    this.state.messageInfo ?
                        <InfoModal
                            isOpen={this.state.messageInfo}

                            toggle={() => this.setState({ messageInfo: null })}
                            header={'Info'.translate(this.props.lang)}
                            info={this.state.messageInfo}
                            buttons={[
                                <Button color='primary' onClick={() => {
                                    this.setState({
                                        messageInfo: null,
                                    })

                                }}>{'Close'.translate(this.props.lang)}</Button>
                            ]}
                        />
                        :
                        null

                }
                {
                    this.state.transferModal ?
                        eConnectEnabled ?
                            <ConsultationModal
                                {...this.props}
                                isOpen={this.state.transferModal}
                                referral={this.state.transferModal}
                                closeModal={() => this.setState({ transferModal: null }, () => {
                                    this.get()
                                })}
                            />
                            :
                            <Modal isOpen={this.state.transferModal} centered>
                                <ModalHeader toggle={() => this.setState({ transferModal: !this.state.transferModal, selectedDoctor: -1 })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ transferModal: !this.state.transferModal, selectedDoctor: -1 })}><Isvg src={xIcon} /></button>}>
                                    <h4>{'Transfer modal'.translate(this.props.lang)}</h4>
                                </ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <Label>{'Transfer from'.translate(this.props.lang)}</Label>
                                        <Input type='text' disabled
                                            value={this.state.transferModal.doctorName} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>{'Transfer to'.translate(this.props.lang)}</Label>
                                        <Input type='select'
                                            value={this.state.selectedDoctor}
                                            onChange={(e) => {
                                                this.setState({ selectedDoctor: e.target.value })
                                            }}
                                        >
                                            <option value={-1}>{'None'.translate(this.props.lang)}</option>
                                            {

                                                this.state.subAccounts && this.state.subAccounts.filter(el => el._id != this.state.transferModal.patientId).sort((a, b) => {
                                                    const nameA = a.name.toLowerCase();
                                                    const nameB = b.name.toLowerCase();
                                                    if (nameA < nameB) {
                                                        return -1
                                                    }
                                                    if (nameA > nameB) {
                                                        return 1
                                                    }
                                                }).map((item, idx) => {
                                                    if (item._id != this.state.transferModal.recipientUser)
                                                        return (
                                                            <option value={item._id}>{item.name}</option>
                                                        )
                                                })
                                            }
                                        </Input>
                                    </FormGroup>

                                </ModalBody>
                                <ModalFooter className='buttons-right-blue'>

                                    <Button color="primary" disabled={this.state.selectedDoctor == -1 || this.state.loadingTransfer ? true : false} onClick={() => this.transferReferral(this.state.transferModal)}>{'Transfer'.translate(this.props.lang)}</Button>

                                    <Button color="primary" onClick={() => this.setState({ transferModal: !this.state.transferModal, selectedDoctor: -1 })}>{'Close'.translate(this.props.lang)}</Button>

                                </ModalFooter>
                            </Modal>
                        :
                        null
                }
                {this.state.errorOverlap ?
                    <Modal isOpen={this.state.errorOverlap} centered>
                        {/* <ModalHeader style={{ margin: 'auto' }}>{'Error'.translate(this.props.lang)}</ModalHeader> */}
                        <ModalBody className="delete-modal">
                            {/* <img src={warrning} /> */}
                            <div className="message">
                                {this.state.errorOverlap && this.state.errorOverlap.message}
                            </div>
                        </ModalBody>
                        <ModalFooter style={{ display: 'flex', justifyContent: 'center', }} className="buttons-right-blue">
                            <Button style={{ minWidth: 100 }} color="primary" onClick={() => {
                                console.log(this.state.errorOverlap)
                                this.props[0].history.push({
                                    pathname: '/my-data/referrals/schedule',
                                    search: '?fromAllCases=true',
                                    state: {
                                        doctor: this.state.errorOverlap && this.state.errorOverlap.doctor,
                                        day: new Date((this.state.errorOverlap && this.state.errorOverlap.date) * 1000),
                                        step: 5,
                                        referralToOpen: this.state.errorOverlap?.referral
                                    }
                                })
                            }} >{'Manage in calender'.translate(this.props.lang)}</Button>
                            <Button style={{ minWidth: 100 }} color="primary" onClick={() => this.setState({ errorOverlap: null })} >{'Close'.translate(this.props.lang)}</Button>{' '}
                        </ModalFooter>
                    </Modal>

                    :
                    null
                }
                {this.state.patientProfile ?
                    <Modal isOpen={this.state.patientProfile} centered>
                        <ModalHeader toggle={() => this.setState({ patientProfile: !this.state.patientProfile })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ patientProfile: !this.state.patientProfile })}><Isvg src={xIcon} /></button>}>
                            <h4>{'Patient profile'.translate(this.props.lang)}</h4>
                        </ModalHeader>
                        <ModalBody>
                            <FormGroup>
                                <Label>{'Social security number'.translate(this.props.lang)}</Label>
                                <Input type='text' disabled
                                    value={this.state.patientProfile.patient?.socialSecurityNumber} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{'Name'.translate(this.props.lang)}</Label>
                                <Input type='text' disabled
                                    value={this.state.patientProfile.patient?.name} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{'Email'.translate(this.props.lang)}</Label>
                                <Input type='text' disabled
                                    value={this.state.patientProfile.patient?.parents && this.state.patientProfile.patient?.parents[0] && this.state.patientProfile.patient?.parents[0].email ? this.state.patientProfile.patient?.parents[0].email : this.state.patientProfile.patient?.email} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{'Phone'.translate(this.props.lang)}</Label>
                                <Input type='text' disabled
                                    value={this.state.patientProfile.patient?.parents && this.state.patientProfile.patient?.parents[0] && this.state.patientProfile.patient?.parents[0].phone ? this.state.patientProfile.patient?.parents[0].phone : this.state.patientProfile.patient?.phone} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{'Address'.translate(this.props.lang)}</Label>
                                <Input type='text' disabled
                                    value={this.state.patientProfile.patient?.parents && this.state.patientProfile.patient?.parents[0] && this.state.patientProfile.patient?.parents[0].address ? this.state.patientProfile.patient?.parents[0].address : this.state.patientProfile.patient?.street + ',' + ' ' + this.state.patientProfile.patient?.zip + ' ' + this.state.patientProfile.patient?.city} />
                            </FormGroup>


                        </ModalBody>
                        <ModalFooter className='buttons-right-blue'>
                            <Button color="primary" onClick={() => this.setState({ patientProfile: !this.state.patientProfile })}>{'Close'.translate(this.props.lang)}</Button>

                        </ModalFooter>
                    </Modal>

                    : null}
                {
                    this.state.previewAnswersReferralModal ?
                        <Modal isOpen={this.state.previewAnswersReferralModal} centered toggle={() => this.setState({ previewAnswersReferralModal: !this.state.previewAnswersReferralModal })} size="lg">
                            <ModalHeader toggle={() => this.setState({ previewAnswersReferralModal: !this.state.previewAnswersReferralModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ previewAnswersReferralModal: !this.state.previewAnswersReferralModal })}><Isvg src={xIcon} /></button>}>{'Form preview'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>

                                <FormPreview {...this.props} referral={{ name: this.state.previewAnswersReferralModal.name, description: this.state.previewAnswersReferralModal.description, intelligentReferral: this.state.previewAnswersReferralModal.intelligentReferral, items: this.state.previewAnswersReferralModal.questionaryData?.items, group: this.props.uData?.clinicGroups[selectedGroupIdx]?._id }} sections={this.generateSections(this.state.previewAnswersReferralModal.questionaryData.items)} answers={this.state.previewAnswersReferralModal.answers} disabledForm={true} hidePreview={true}></FormPreview>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.previewAnswersModal ?
                        <Modal isOpen={this.state.previewAnswersModal} centered toggle={() => this.setState({ previewAnswersModal: !this.state.previewAnswersModal })} size="lg">
                            <ModalHeader toggle={() => this.setState({ previewAnswersModal: !this.state.previewAnswersModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ previewAnswersModal: !this.state.previewAnswersModal })}><Isvg src={xIcon} /></button>}>{'Form preview'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>

                                <FormPreview {...this.props} referral={{ _id: this.state.previewAnswersModal._id, name: this.state.previewAnswersModal.name, description: this.state.previewAnswersModal.description, intelligentReferral: this.state.previewAnswersModal.intelligentReferral, items: this.state.previewAnswersModal.items, group: this.props.uData?.clinicGroups[selectedGroupIdx]?._id }} sections={this.generateSections(this.state.previewAnswersModal.items)} answers={this.state.previewAnswersModal.answers} disabledForm={true} hidePreview={true}></FormPreview>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.referral ?
                        <ReferralContent
                            {...this.props}
                            data={this.state.referral}
                            screen={'received-referrals'}
                            doctorPage={true}
                            enterprise={enterprise}
                            adminPermission={this.state.adminPermission}
                            generateTimeReferral={(referral) => { this.generateTimeReferral(referral) }}
                            allowReferral={() => { this.allowReferral() }}
                            disallowReferral={(referral) => { this.setState({ disallowForm: referral }) }}
                            acceptReferral={() => this.acceptReferral()}
                            rejectReferral={() => this.rejectReferral()}
                            acceptRequestedTime={() => this.acceptRequestedTime()}
                            removeReferralModal={(item) => this.setState({ removeReferralModal: { ...item } })}
                            eConnectEnabled={eConnectEnabled}
                            startTransferConsultation={async (item) => {
                                if (eConnectEnabled && this.props.checkIfConsultationExists && item?._id) {
                                    let consultationExists = await this.props.checkIfConsultationExists(item._id, () => {
                                        this.setState({ transferModal: item })
                                    });
                                    if (!consultationExists)
                                        this.setState({ transferModal: item })
                                } else {
                                    this.setState({ transferModal: item })
                                }
                            }}
                            rejectRequestedTime={(referral) => {
                                this.setState({ scheduleForm: referral })
                            }}
                            closeCase={() => { this.setState({ closeCase: true }) }}
                            deleteCase={() => { this.setState({ deleteCase: true }) }}

                            previewAnswersRevisit={(form) => {
                                this.setState({ previewAnswersModal: form })
                            }}
                            closeReferralContent={(data) => {
                                if (this.state.referral) {
                                    this.setState({
                                        referral: null
                                    })
                                }
                            }}
                            setData={(data, refresh = false) => {
                                if (data) {
                                    let referral = this.state.referral;
                                    if (data && Object.keys(data)?.length) {
                                        for (var key in data) {
                                            referral[key] = data[key];
                                        }

                                        this.setState({ referral }, () => {
                                            if (refresh) {
                                                this.get();
                                            }
                                        })
                                    }
                                }
                            }}
                        />
                        :
                        null
                }
                {this.state.referral && false ?
                    <Modal isOpen={this.state.referral} centered toggle={() => this.setState({ referral: !this.state.referral })} size="lg" className="modal-footer-modifed modal-header-unpaid">
                        <ModalHeader toggle={() => this.setState({ referral: !this.state.referral })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ referral: !this.state.referral })}><Isvg src={xIcon} /></button>}>
                            <div className='unpaid-header'>
                                <p>{'Referral preview'.translate(this.props.lang)}</p>
                            </div>
                        </ModalHeader>

                        <ModalBody>
                            <div className='unpaid-button-container'>
                                {
                                    this.state.referral.referralIsPaid || (this.state.referral.event && this.state.referral.event.appointmentPaid) || (this.state.referral.event && this.state.referral.event.visitReasonPrice == 0) || this.state.referral.questionaryPrice == 0 ?
                                        null
                                        :
                                        <button>
                                            <Isvg src={billInfoIcon} />
                                            {'UNPAID'.translate(this.props.lang)}
                                        </button>
                                }
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: this.props.lang == 'se' ? this.state.referral.referralContent.protectReferralFiles(this.props.uData ? this.props.uData.mediaToken : '', this.state.referral._id) : this.state.referral.referralContentEn ? this.state.referral.referralContentEn.protectReferralFiles(this.props.uData ? this.props.uData.mediaToken : '', this.state.referral._id) : this.state.referral.referralContent.protectReferralFiles(this.props.uData ? this.props.uData.mediaToken : '', this.state.referral._id) }} onChange={() => { }}></div>
                            {
                                enterprise && this.state.referral.revisitFormsArray && this.state.referral.revisitFormsArray.length && this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1] ?
                                    this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralData ?
                                        <div>
                                            <h6>{'Patient answers'.translate(this.props.lang)} <span style={{ marginLeft: 20, fontWeight: 600 }}>{this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].name}</span> </h6>
                                            <div dangerouslySetInnerHTML={{ __html: this.props.lang == 'se' ? this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralData.protectReferralFiles(this.props.uData ? this.props.uData.mediaToken : '', this.state.referral._id) : this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralDataEn ? this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralDataEn.protectReferralFiles(this.props.uData ? this.props.uData.mediaToken : '', this.state.referral._id) : this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralData.protectReferralFiles(this.props.uData ? this.props.uData.mediaToken : '', this.state.referral._id) }}></div>

                                            {/* <div dangerouslySetInnerHTML={{ __html: this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralData.protectReferralFiles(this.props.uData ? this.props.uData.mediaToken : '', this.state.referral._id) }}></div> */}
                                            {/* <div dangerouslySetInnerHTML={{ __html: this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralData }}></div> */}
                                            {
                                                this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralTotalData ?
                                                    // <div dangerouslySetInnerHTML={{ __html: this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralTotalData.protectReferralFiles(this.props.uData ? this.props.uData.mediaToken : '', this.state.referral._id) }}></div>
                                                    <div dangerouslySetInnerHTML={{ __html: this.props.lang == 'se' ? this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralTotalData.protectReferralFiles(this.props.uData ? this.props.uData.mediaToken : '', this.state.referral._id) : this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralTotalDataEn ? this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralTotalDataEn.protectReferralFiles(this.props.uData ? this.props.uData.mediaToken : '', this.state.referral._id) : this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralTotalData.protectReferralFiles(this.props.uData ? this.props.uData.mediaToken : '', this.state.referral._id) }}></div>
                                                    :
                                                    null
                                            }

                                            {/* <div dangerouslySetInnerHTML={{ __html: this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].referralTotalData }}></div> */}
                                            <Button color='primary' onClick={() => { this.setState({ previewAnswersModal: this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1] }) }}>{'Preview answers'.translate(this.props.lang)}</Button>
                                            <hr />
                                        </div>
                                        :
                                        <div>
                                            <h6>{'Patient answers'.translate(this.props.lang)} <span style={{ marginLeft: 20, fontWeight: 600 }}>{this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].name}</span> </h6>
                                            <p style={{ fontStyle: 'italic', fontSize: 14 }}>{'The patient did not fill out the form'.translate(this.props.lang)}</p>
                                            <hr />
                                        </div>

                                    :
                                    null
                            }
                            {
                                this.state.referral && this.state.referral.answers && this.state.referral.questionaryData && this.state.referral.questionaryData.items ?
                                    <div style={{ marginBottom: 10 }}>
                                        <Button color='primary' onClick={() => { this.setState({ previewAnswersReferralModal: this.state.referral }) }}>{'Preview answers'.translate(this.props.lang)}</Button>
                                    </div>
                                    :
                                    null
                            }
                            <div className='patient-referral-preview-status-wrap'>
                                <div>
                                    <p> <strong>{'Status:'.translate(this.props.lang)}</strong> {humanReadable[this.state.referral.status]}</p>
                                    {this.state.referral.reason ?
                                        <p> <strong>{'Reason:'.translate(this.props.lang)}</strong> {this.state.referral.reason}</p>
                                        :
                                        null}
                                    {this.state.referral.patientReservedTimestamp ?
                                        <p> <strong>{'Scheduled time:'.translate(this.props.lang)}</strong> {this.props.getStringDateTs(this.state.referral.patientReservedTimestamp, `${this.props.dateFormat} HH:mm`)/*moment.unix(this.state.referral.patientReservedTimestamp).format(`${this.props.dateFormat} HH:mm`)*/}</p>
                                        :
                                        null}

                                    {
                                        this.state.referral.status == 'patient-requested-another-time' ?
                                            <p> <strong>{'Requested time:'.translate(this.props.lang)}</strong> {this.props.getStringDateTs(this.state.referral.patientRequestedTimestamp, `${this.props.dateFormat} HH:mm`)/*moment.unix(this.state.referral.patientRequestedTimestamp).format(`${this.props.dateFormat} HH:mm`)*/}</p>

                                            :
                                            null
                                    }

                                </div>
                                {
                                    enterprise && this.state.referral.revisitFormsArray && this.state.referral.revisitFormsArray.length ?
                                        <div className='doctor-preview-revisit-forms'>
                                            <div className='doctor-preview-revisit-forms-header'>
                                                {
                                                    this.state.activeRevisitForm ?
                                                        <span>{this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1].name} <span>({this.state.activeRevisitForm}/{this.state.referral.revisitFormsArray.length})</span></span>
                                                        :
                                                        <span>{this.state.referral.revisitFormsArray[0].name} <span>(1/{this.state.referral.revisitFormsArray.length})</span></span>
                                                }
                                            </div>
                                            <div className='buttons-next-prev-wrap'>
                                                <Button color='primary' disabled={this.state.activeRevisitForm && this.state.activeRevisitForm > 1 ? false : true} onClick={() => {
                                                    let activeRevisitForm = this.state.activeRevisitForm;
                                                    if (!activeRevisitForm) {
                                                        activeRevisitForm = 1;
                                                    }
                                                    if (activeRevisitForm > 1) {
                                                        activeRevisitForm--;
                                                    }
                                                    this.setState({ activeRevisitForm })
                                                }}>{'Previous'.translate(this.props.lang)}</Button>
                                                <Button color='primary' disabled={this.state.activeRevisitForm && this.state.activeRevisitForm < this.state.referral.revisitFormsArray.length ? false : true} onClick={() => {
                                                    let activeRevisitForm = this.state.activeRevisitForm;
                                                    if (!activeRevisitForm) {
                                                        activeRevisitForm = 1;
                                                    }
                                                    if (activeRevisitForm < this.state.referral.revisitFormsArray.length) {
                                                        activeRevisitForm++;
                                                    }
                                                    this.setState({ activeRevisitForm })
                                                }}>{'Next'.translate(this.props.lang)}</Button>
                                            </div>
                                        </div>
                                        :
                                        null

                                }
                            </div>


                        </ModalBody>
                        {this.state.referral.status == 'waiting-for-approval' || this.state.referral.status == 'approved-by-region-manager' || this.state.referral.status == 'rejected-by-region-manager' ?
                            <ModalFooter style={{ margin: 'unset', justifyContent: 'flex-end', display: 'flex', width: '100%' }} className="buttons-right-blue">

                                {!this.state.referral.forwardRecipientClinic && !this.state.referral.forward && this.props.uData && this.props.uData.profession && this.props.uData.profession[this.props.selectedGroup] && this.state.referral.professionList && this.state.referral.professionList.filter(profession => {
                                    if (typeof this.props.uData.profession[this.props.selectedGroup] !== 'string') {
                                        return this.props.uData.profession[this.props.selectedGroup].indexOf(profession) !== -1
                                    } else {
                                        return profession == this.props.uData.profession[this.props.selectedGroup]
                                    }

                                }).length ?
                                    <>
                                        <Button color="success" onClick={() => this.allowReferral()}><><i className="fa fa-check" />{'Allow'.translate(this.props.lang)}</></Button>
                                        <Button color="danger" onClick={() => this.setState({ disallowForm: this.state.referral })}><i className="fa fa-close" /> {'Disallow'.translate(this.props.lang)} </Button>


                                    </>
                                    :
                                    null


                                }

                                {
                                    this.state.referral.forwardRecipientClinic && this.state.referral.forward ?
                                        <>
                                            <Button color="success" onClick={() => this.acceptReferral()}><i className="fa fa-check" /> {'Accept'.translate(this.props.lang)}</Button>
                                            <Button color="danger" onClick={() => this.rejectReferral({})}><i className="fa fa-close" /> {'Reject'.translate(this.props.lang)} </Button>
                                        </>

                                        :
                                        null
                                }


                                <PrintHelper lang={this.props.lang} html={this.props.lang == 'se' ? this.state.referral.referralContent : this.state.referral.referralContentEn ? this.state.referral.referralContentEn : this.state.referral.referralContent} />
                                <Button color="primary" onClick={() => this.setState({ referral: null })}> {'Close'.translate(this.props.lang)} </Button>

                            </ModalFooter>
                            :
                            this.state.referral.status == 'allowed' || this.state.referral.status == 'not-booked' ?
                                <ModalFooter style={{ margin: 'unset', justifyContent: 'flex-end', display: 'flex', width: '100%' }} className="buttons-right-blue">

                                    <Button color="primary" style={{ margin: 10 }} onClick={() => this.generateTimeReferral(this.state.referral)}> {'ScheduleList'.translate(this.props.lang)} </Button>
                                    <PrintHelper lang={this.props.lang} html={this.props.lang == 'se' ? this.state.referral.referralContent : this.state.referral.referralContentEn ? this.state.referral.referralContentEn : this.state.referral.referralContent} />
                                    <Button color="primary" onClick={() => this.setState({ referral: null })}> {'Close'.translate(this.props.lang)} </Button>



                                </ModalFooter>
                                :
                                this.state.referral.status == 'patient-requested-another-time' ?
                                    <ModalFooter>

                                        <Button color="success" onClick={() => this.acceptRequestedTime()}><i className="fa fa-check" /> {'Accept requested time'.translate(this.props.lang)}</Button>
                                        <Button color="danger" onClick={() => this.setState({ scheduleForm: this.state.referral })}><i className="fa fa-close" /> {'Reject requested time'.translate(this.props.lang)} </Button>
                                        <PrintHelper lang={this.props.lang} html={this.state.referral.referralContent} />

                                        <Button color="primary" onClick={() => this.setState({ referral: null })}> {'Close'.translate(this.props.lang)} </Button>

                                    </ModalFooter>
                                    :
                                    <ModalFooter style={{ margin: 'unset', justifyContent: 'flex-end', display: 'flex', width: '100%' }} className="buttons-right-blue">

                                        {
                                            this.state.referral.status == 'scheduled' || this.state.referral.status === 'visit-rescheduled' || this.state.referral.status == 'patient-rejected' || this.state.referral.status == 'not-booked' ?
                                                <div className='red-button-wrap'>
                                                    <Button onClick={() => this.setState({ closeCase: true })} color="danger">{'Close case'.translate(this.props.lang)}</Button>

                                                </div>
                                                :
                                                null
                                        }
                                        {
                                            (this.state.referral.status == 'scheduled' || this.state.referral.status === 'visit-rescheduled') && this.state.adminPermission ?
                                                <Button color="primary" style={{ margin: 10 }} onClick={() => {
                                                    this.props[0].history.push({
                                                        pathname: '/my-data/referrals/schedule',
                                                        search: '?fromAllCases=true',
                                                        state: {
                                                            doctor: this.state.referral.recipientUser,
                                                            day: new Date(this.state.referral.patientReservedTimestamp * 1000),
                                                            step: 5,
                                                            referralToOpen: this.state.referral?._id
                                                        }
                                                    })
                                                }}> {'Manage in calendar'.translate(this.props.lang)} </Button>
                                                :
                                                null
                                        }



                                        {
                                            enterprise && this.state.referral.revisitFormsArray && this.state.referral.revisitFormsArray.length && this.state.referral.revisitFormsArray[this.state.activeRevisitForm - 1] ?
                                                <PrintHelper lang={this.props.lang} html={this.generateHtmlForPrint()} />

                                                :
                                                <PrintHelper lang={this.props.lang} html={this.props.lang == 'se' ? this.state.referral.referralContent : this.state.referral.referralContentEn ? this.state.referral.referralContentEn : this.state.referral.referralContent} />

                                        }
                                        {/* <PrintHelper lang={this.props.lang} html={this.props.lang == 'se' ? this.state.referral.referralContent : this.state.referral.referralContentEn ? this.state.referral.referralContentEn : this.state.referral.referralContent} /> */}

                                        <Button color="primary" onClick={() => this.setState({ referral: null })}> {'Close'.translate(this.props.lang)} </Button>

                                    </ModalFooter>

                        }

                    </Modal>

                    :
                    null
                }
                {
                    this.state.closeCase ?
                        <Modal isOpen={this.state.closeCase} centered>
                            {/* <ModalHeader style={{ margin: 'auto' }}>{'Warning'.translate(this.props.lang)}</ModalHeader> */}
                            <ModalBody className="delete-modal">
                                {/* <img src={warrning} /> */}
                                <p className="message">{`Are you sure you want to close the case?`.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ closeCase: false }, () => this.closeReferral())}>{'Yes'.translate(this.props.lang)}</Button>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ closeCase: false })}>{'No'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        : null
                }
                {
                    this.state.deleteCase ?
                        <Modal isOpen={this.state.deleteCase} centered>
                            <ModalBody className="delete-modal">
                                <p className="message">{`Are you sure you want to delete the case?`.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ deleteCase: false }, () => this.deleteReferral())}>{'Yes'.translate(this.props.lang)}</Button>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ deleteCase: false })}>{'No'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        : null
                }

                {
                    this.state.disallowForm ?
                        <FormBuilder selectedGroup={this.props.selectedGroup} selectedClinic={this.props.selectedClinic} countryTwoLetter={this.props.countryTwoLetter} country={this.props.country} dateFormat={this.props.dateFormat}
                            getStringDateTs={this.props.getStringDateTs}
                            lang={this.props.lang}
                            onSubmit={(data) => this.disallowReferral(data)}
                            isOpen={this.state.disallowForm}
                            toggle={() => this.setState({ disallowForm: null })}
                            title={'Disallow referral'.translate(this.props.lang)}
                            buttonText={'Submit'.translate(this.props.lang)}
                            fields={[
                                {
                                    type: 'row',
                                    children: [
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 12,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'textarea',
                                                    name: 'reason',
                                                    label: 'Give reason'.translate(this.props.lang),
                                                    validate: [required('Reason is required!'.translate(this.props.lang))]
                                                },
                                            ]
                                        },

                                    ]
                                }
                            ]}
                        ></FormBuilder>
                        :
                        null
                }
                {
                    this.state.returnForm ?
                        <FormBuilder selectedGroup={this.props.selectedGroup} selectedClinic={this.props.selectedClinic} countryTwoLetter={this.props.countryTwoLetter} country={this.props.country} dateFormat={this.props.dateFormat}
                            getStringDateTs={this.props.getStringDateTs}
                            lang={this.props.lang}
                            onSubmit={(data) => this.returnForUpdate(data)}
                            isOpen={this.state.returnForm}
                            toggle={() => this.setState({ returnForm: null })}
                            title={'Return for referral update'.translate(this.props.lang)}
                            buttonText={'Submit'.translate(this.props.lang)}
                            fields={[
                                {
                                    type: 'row',
                                    children: [
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 12,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'textarea',
                                                    name: 'reason',
                                                    label: 'Reason'.translate(this.props.lang),
                                                    validate: [required('Reason is required!'.translate(this.props.lang))]
                                                },
                                            ]
                                        },

                                    ]
                                }
                            ]}
                        ></FormBuilder>
                        :
                        null
                }

                {
                    this.state.allowForm ?
                        <FormBuilder selectedGroup={this.props.selectedGroup} selectedClinic={this.props.selectedClinic} countryTwoLetter={this.props.countryTwoLetter} country={this.props.country} dateFormat={this.props.dateFormat}
                            getStringDateTs={this.props.getStringDateTs}
                            lang={this.props.lang}
                            onSubmit={(data) => this.allowReferral(data)}
                            isOpen={this.state.allowForm}
                            toggle={() => this.setState({ allowForm: null })}
                            title={'Allow referral'.translate(this.props.lang)}
                            buttonText={'Submit'.translate(this.props.lang)}
                            fields={[
                                {
                                    type: 'row',
                                    children: [
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 6,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'date',
                                                    name: 'date',
                                                    label: 'Date'.translate(this.props.lang),
                                                    validate: [required('Date is required!'.translate(this.props.lang))]
                                                },
                                            ]
                                        },
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 6,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'time',
                                                    name: 'time',
                                                    label: 'Time'.translate(this.props.lang),
                                                    validate: [required('Time is required!'.translate(this.props.lang))]
                                                },
                                            ]
                                        },
                                    ]
                                }
                            ]}
                        ></FormBuilder>
                        :
                        null
                }


                {
                    this.state.scheduleForm ?
                        <FormBuilder selectedGroup={this.props.selectedGroup} selectedClinic={this.props.selectedClinic} countryTwoLetter={this.props.countryTwoLetter} country={this.props.country} dateFormat={this.props.dateFormat}
                            getStringDateTs={this.props.getStringDateTs}
                            lang={this.props.lang}
                            onSubmit={(data) => this.rejectRequestedTime(data)}
                            isOpen={this.state.scheduleForm}
                            toggle={() => this.setState({ scheduleForm: null })}
                            title={'Schedule new time'.translate(this.props.lang)}
                            buttonText={'Submit'.translate(this.props.lang)}
                            fields={[
                                {
                                    type: 'row',
                                    children: [
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 6,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'date',
                                                    name: 'date',
                                                    label: 'Date'.translate(this.props.lang),
                                                    validate: [required('Date is required!'.translate(this.props.lang))]
                                                },
                                            ]
                                        },
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 6,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'time',
                                                    name: 'time',
                                                    label: 'Time'.translate(this.props.lang),
                                                    validate: [required('Time is required!'.translate(this.props.lang))]
                                                },
                                            ]
                                        },
                                    ]
                                }
                            ]}
                        ></FormBuilder>
                        :
                        null
                }


                {
                    this.state.selectClinicModal ?
                        <Modal isOpen={this.state.selectClinicModal} centered toggle={() => this.setState({ selectClinicModal: !this.state.selectClinicModal })} size="xl">
                            <ModalHeader>
                                <h4>{'Search Curoflow database'.translate(this.props.lang)}</h4>
                            </ModalHeader>
                            <ModalBody>
                                <ReferralClinics {...this.props} patientData={this.state.patientData} searchFor={this.state.referral.articleName} includeTags={this.state.tags} importClinic={(clinic) => {
                                    this.setState({
                                        checkForward: clinic
                                    })
                                    //this.forward(clinic);
                                    /*let addressLines = [];
                                    if (clinic.postAddress) {
                                        addressLines = this.splitAddress(clinic.postAddress);
                                    } else {
                                        addressLines = [clinic.street, clinic.zip + ' ' + clinic.city, ''];
                                    }
                 
                                    this.setState({
                                        recipientData: {
                                            ...clinic,
                                            name: clinic.vantetiderName ? clinic.vantetiderName : clinic.name,
                                            address1: addressLines[0],
                                            address2: addressLines[1],
                                            address3: addressLines[2]
                                        },
                                        selectClinicModal: null
                                    })*/
                                }}></ReferralClinics>
                            </ModalBody>
                        </Modal>
                        :
                        null
                }

                {
                    this.state.checkForward ?
                        <Modal isOpen={this.state.checkForward} centered toggle={() => this.setState({ checkForward: !this.state.checkForward })} size="xl">
                            {/* <ModalHeader>
                                <h4></h4>
                            </ModalHeader> */}
                            <ModalBody className='delete-modal'>
                                <p> {'Are you shure that you want to continue?'.translate(this.props.lang)}  {'This referral will be sent to'.translate(this.props.lang)} {this.state.checkForward.name}.</p>
                            </ModalBody>
                            <ModalFooter className='button-right-blue'>
                                <Button style={{ minWidth: 100 }} onClick={() => this.forward(this.state.checkForward)}>{'Continue'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.managerModal ?
                        <Modal isOpen={this.state.managerModal} centered toggle={() => this.setState({ managerModal: !this.state.managerModal })} >
                            <ModalHeader>
                                <h4>{'Request for payment'.translate(this.props.lang)}</h4>
                            </ModalHeader>
                            <ModalBody>
                                <div>
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input" onChange={() => this.setState({ changeButton: !this.state.changeButton })} />
                                        <label class="form-check-label" for="paymentChecked" >Accept payment</label>
                                    </div>
                                    <Button onClick={this.state.changeButton ? () => { this.managerMail(this.state.managerModal), this.setState({ changeButton: !this.state.changeButton }) } : () => this.setState({ signinModal: this.state.managerModal, managerModal: false })}>{this.state.changeButton ? 'Sent to region manager' : 'Sign and allow'}</Button>


                                </div>
                            </ModalBody>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.closeCaseActionModal ?
                        <ErrorModalV2
                            isOpen={this.state.closeCaseActionModal}
                            modalFooterClassName={'modal-footer-buttons-wrap'}
                            buttons={[
                                {
                                    text: 'Close case and keep calendar post'.translate(this.props.lang),
                                    onClick: () => {
                                        const data = this.state.closeCaseActionModal?.data;
                                        const func = this.state.closeCaseActionModal?.function;
                                        this.setState({ closeCaseActionModal: false }, () => {
                                            if (func === 'closeReferral') {
                                                this.closeReferral(data, 'keepCalendarPost');
                                            }
                                        })
                                    }
                                },
                                {
                                    text: 'Close case and delete calendar post'.translate(this.props.lang),
                                    onClick: () => {
                                        const data = this.state.closeCaseActionModal?.data;
                                        const func = this.state.closeCaseActionModal?.function;
                                        this.setState({ closeCaseActionModal: false }, () => {
                                            if (func === 'closeReferral') {
                                                this.closeReferral(data, 'deleteCalendarPost');
                                            }
                                        })
                                    }
                                },
                                {
                                    text: 'Cancel'.translate(this.props.lang),
                                    onClick: () => {
                                        this.setState({ closeCaseActionModal: false })
                                    }
                                }
                            ]}
                        >
                            {'Do you also want to delete the calendar post?'.translate(this.props.lang)}
                        </ErrorModalV2>
                        :
                        null
                }

                {
                    this.state.errorAdditionalDoctors ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.errorAdditionalDoctors}
                            toggle={() => {

                                this.setState({ errorAdditionalDoctors: null })
                            }}

                        >
                            {
                                this.state.errorAdditionalDoctors && this.state.errorAdditionalDoctors.map((item, idx) => {
                                    return (
                                        <div>
                                            <span style={{ fontWeight: 600 }}>
                                                {item.doctorName}  {' - '}
                                            </span>

                                            {
                                                item.available ?
                                                    <span style={{ color: 'green' }}>{'Available'.translate(this.props.lang)}</span>
                                                    :
                                                    <span style={{ color: 'red' }}>{'Unavailable'.translate(this.props.lang)}</span>
                                            }

                                        </div>
                                    )
                                })

                            }
                        </ErrorModal>
                        :
                        null
                }
                {
                    this.state.doctorsModal ?
                        <Modal size="lg" isOpen={this.state.doctorsModal} centered toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} >
                            <ModalHeader toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ doctorsModal: !this.state.doctorsModal })}><Isvg src={xIcon} /></button>}>{'Choose doctors'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody className="run-modal">
                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (this.props.uData._id && item._id != this.props.uData._id) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <FormGroup >
                                            <Label>{'Search'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={this.state.filterDoctors ? this.state.filterDoctors : ''} onChange={(e) => {
                                                this.setState({
                                                    filterDoctors: e.target.value
                                                })
                                            }} />

                                        </FormGroup>
                                        :
                                        null
                                }
                                <FormGroup className="form-group-checkbox">
                                    {
                                        this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                            if (this.state.listDoctor && item._id != this.state.listDoctor) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }).length ?
                                            <DoctorListComponent
                                                value={this.state.doctorsList ? this.state.doctorsList : []}
                                                values={this.state.doctors.sort((a, b) => {
                                                    const nameA = a.name;
                                                    const nameB = b.name;
                                                    if (nameA < nameB) {
                                                        return -1
                                                    }
                                                    if (nameA > nameB) {
                                                        return 1
                                                    }
                                                }).filter(doc => doc._id !== this.state.listDoctor && doc.name.toLowerCase().indexOf(this.state.filterDoctors ? this.state.filterDoctors.toLowerCase() : ' ') != -1).map(item => {
                                                    return ({
                                                        name: item.name,
                                                        value: item._id,
                                                        profilePicture: item.profilePicture,
                                                        username: item.username
                                                    })
                                                })}
                                                onChange={(item) => {
                                                    let doctorsList = this.state.doctorsList;
                                                    doctorsList = [...item]
                                                    this.setState({ doctorsList })
                                                }}
                                            />
                                            :
                                            "The doctor's list is empty".translate(this.props.lang)
                                    }
                                </FormGroup>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (this.props.uData._id && item._id != this.props.uData._id) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <Button color='primary'
                                            // disabled={this.state.doctorsList && this.state.doctorsList.length > 0 ? false : true}
                                            onClick={() =>
                                                this.checkDoctorsAvailable(this.state.doctorsList, this.state.doctorsModal)
                                            }>{'Save'.translate(this.props.lang)}</Button>
                                        :
                                        null
                                }
                                <Button color='primary' onClick={() => {
                                    // console.log(this.state.doctorsList)
                                    // console.log(this.state.updateEvent.additionalDoctors)
                                    this.setState({ doctorsModal: false })
                                }
                                }>{"Close".translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }

                {
                    this.state.conversationModal ?
                        <Modal isOpen={this.state.conversationModal} centered toggle={() => this.setState({ conversationModal: !this.state.conversationModal })} >
                            <ModalHeader>
                                <h4>{'Start conversation or enter existing conversation'.translate(this.props.lang)}</h4>
                            </ModalHeader>
                            <ModalBody>
                                {this.state.conversationModal.conversations.length ?
                                    <>
                                        <h6>{'Existing conversations'.translate(this.props.lang)}</h6>
                                        <Table responsive>
                                            <thead>
                                                <tr>
                                                    <th>{'Conversation name'.translate(this.props.lang)}</th>
                                                    <th>{'Clinic doctor'.translate(this.props.lang)}</th>
                                                    <th>{'Patient'.translate(this.props.lang)}</th>
                                                    <th>{'Action'.translate(this.props.lang)}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.conversationModal.conversations.map((item, idx) => {
                                                        return (
                                                            <tr>
                                                                <td>{item.name}</td>

                                                                <td><Checkbox checked={item._doctorIncludedInConversation} /></td>
                                                                <td><Checkbox checked={item._patientIncludedInConversation} /></td>
                                                                <td>
                                                                    <Link to={`/chat?conversation=${item._id}`}> <div className="tabel-action-tooltip"> < Isvg src={openChat} style={{ width: 21 }} /><div className="chat-icons-tooltip">{'Resume existing conversation'.translate(this.props.lang)}</div> </div> </Link>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>
                                        </Table>
                                    </>
                                    :
                                    null
                                }

                                <h6>{'New conversation:'.translate(this.props.lang)}</h6>
                                {/*<FormGroup>
                                    <Label >{'Conversation name'.translate(this.props.lang)}</Label>
                                    <Input value={this.state.conversationForm.name} onChange={(e) => {
                                        let conversationForm = this.state.conversationForm;
                                        conversationForm.name = e.target.value;
                                        if (conversationForm.name.indexOf( this.state.conversationModal.patient?.referralNumber ) !== 0) {
                                            conversationForm.name = this.state.conversationModal.patient?.referralNumber;
                                        }
                                        this.setState({ conversationForm })
                                    }} size="sm" />
                                </FormGroup>*/

                                /*<FormGroup check>
                                    <Label check><Input disabled={!this.state.conversationModal._chatWithPatient} value={this.state.conversationForm.patient} onChange={(e) => {
                                        let conversationForm = this.state.conversationForm;
                                        conversationForm.patient = e.target.checked;
                                        this.setState({ conversationForm })
                                    }} type="checkbox" /> &nbsp; {'Patient'.translate(this.props.lang)}</Label>
                                </FormGroup>
                                */}
                                <FormGroup>
                                    <Button size="sm" color="primary" onClick={() => {
                                        this.conversation(this.state.conversationModal._id, { ...this.state.conversationForm, patient: true });
                                    }}>{'Start new conversation'.translate(this.props.lang)}</Button>
                                </FormGroup>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.scheduleListReferral ?
                        <Modal isOpen={this.state.scheduleListReferral} centered>
                            <ModalHeader toggle={() => this.setState({ scheduleReferral: !this.state.scheduleListReferral, doctorsList: [], listDoctor: null })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ scheduleListReferral: !this.state.scheduleListReferral, doctorsList: [], listDoctor: null })}>&times;</button>}>{'Schedule referral'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>

                                <FormGroup>

                                    <Label>{'Doctor'.translate(this.props.lang)}</Label>
                                    <Input type='select'
                                        disabled={!this.state.adminPermission}
                                        onChange={e => this.setState({ listDoctor: e.target.value == -1 ? null : e.target.value, loadingDoctor: true, scroll: false }, () => {
                                            this.getWorkingTime(this.state.listDoctor)
                                        })}
                                        value={this.state.listDoctor}
                                    >
                                        <option value={-1}>{'None'.translate(this.props.lang)}</option>

                                        {this.state.doctors?.filter(userObj => userObj.socialSecurityNumber !== this.state.scheduleListReferral?.patient?.socialSecurityNumber && userObj?.groupPermissions?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.length)?.sort((a, b) => {
                                            const nameA = a.name.toLowerCase();
                                            const nameB = b.name.toLowerCase();
                                            if (nameA < nameB) {
                                                return -1
                                            }
                                            if (nameA > nameB) {
                                                return 1
                                            }
                                        }).map(item => {
                                            return <option value={item._id}>
                                                {item.name} - {item.username}
                                            </option>
                                        })}

                                    </Input>

                                </FormGroup>
                                <FormGroup>

                                    <Label>{'Patient'.translate(this.props.lang)}</Label>
                                    <Input type='text' value={`${this.state.scheduleListReferral.patient?.name}${" " + humanReadable[this.state.scheduleListReferral.status].translate(this.props.lang)}${this.state.scheduleListReferral.onlineVisit ? (' - ' + 'Online'.translate(this.props.lang)) : ''}`}>


                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <DatePicker
                                        label={'Start date'.translate(this.props.lang)}
                                        value={this.state.scheduleListReferral.date}
                                        onChange={(e) => {
                                            let scheduleListReferral = this.state.scheduleListReferral;
                                            scheduleListReferral.date = e;
                                            this.setState({
                                                scheduleListReferral
                                            })
                                            if (Math.floor(new Date(this.state.scheduleListReferral.date + ' ' + this.state.scheduleListReferral.startTime) / 1000) > Math.floor(new Date(this.state.scheduleListReferral.endDate + ' ' + this.state.scheduleListReferral.endTime) / 1000)) {
                                                scheduleListReferral.endDate = this.state.scheduleListReferral.date
                                                this.setState({
                                                    scheduleListReferral
                                                })
                                            }
                                        }}
                                    />
                                </FormGroup>
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'Start time'.translate(this.props.lang)}</Label>
                                    &nbsp;

                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.scheduleListReferral.startTime}
                                        // maxValue={this.state.scheduleReferral.endTime}
                                        minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} //moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')} //moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let scheduleListReferral = this.state.scheduleListReferral;
                                            scheduleListReferral.startTime = timeString

                                            let startTimeSplit = scheduleListReferral.startTime.split(":");
                                            let endTimeSplit = scheduleListReferral.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);
                                            // this.setState({ scheduleListReferral })
                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ scheduleListReferral })
                                            } else {
                                                scheduleListReferral.endTime = Math.trunc((Number(this.state.scheduleListReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleListReferral.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleListReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleListReferral.startTime.split(':')[1]) + 5) % 60
                                                const padded = scheduleListReferral?.endTime?.split?.(':');
                                                if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                    const h = padded[0]?.padStart?.(2, '0');
                                                    const m = padded[1]?.padStart?.(2, '0');
                                                    if (h && m) scheduleListReferral.endTime = `${h}:${m}`;
                                                }
                                                this.setState({
                                                    scheduleListReferral
                                                })
                                            }

                                        }}
                                    />

                                    {/* <TimePicker
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={moment(new Date(this.state.scheduleListReferral.date.replace(/-/g, "/") + " " + this.state.scheduleListReferral.startTime))}
                                        // maxValue={this.state.scheduleReferral.endTime}
                                        minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} //moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} //moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let scheduleListReferral = this.state.scheduleListReferral;
                                            scheduleListReferral.startTime = timeString

                                            let startTimeSplit = scheduleListReferral.startTime.split(":");
                                            let endTimeSplit = scheduleListReferral.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);
                                            this.setState({ scheduleListReferral })

                                        }}
                                        allowClear={false}
                                    /> */}
                                </FormGroup>
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'End time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.scheduleListReferral.endTime}
                                        minValue={Math.trunc((Number(this.state.scheduleListReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleListReferral.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleListReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleListReferral.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} //moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let scheduleListReferral = this.state.scheduleListReferral;
                                            scheduleListReferral.endTime = timeString

                                            let startTimeSplit = scheduleListReferral.startTime.split(":");
                                            let endTimeSplit = scheduleListReferral.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ scheduleListReferral })
                                            }
                                        }}
                                    />
                                    {/* <TimePicker
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={moment(new Date(this.state.scheduleListReferral.date.replace(/-/g, "/") + " " + this.state.scheduleListReferral.endTime))}
                                        minValue={Math.trunc((Number(this.state.scheduleListReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleListReferral.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleListReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleListReferral.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} //moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let scheduleListReferral = this.state.scheduleListReferral;
                                            scheduleListReferral.endTime = timeString

                                            let startTimeSplit = scheduleListReferral.startTime.split(":");
                                            let endTimeSplit = scheduleListReferral.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ scheduleListReferral })
                                            }
                                        }}
                                        allowClear={false}
                                    /> */}
                                </FormGroup>
                                {
                                    this.state.listDoctor && isDurationHideCheckboxAvailable(this.state.scheduleListReferral?._id, this.state.scheduleListReferral) /* && enterprise */ ?
                                        <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    let scheduleListReferral = this.state.scheduleListReferral;
                                                    scheduleListReferral.hideDurationForPatient = e.target.checked;
                                                    this.setState({
                                                        scheduleListReferral
                                                    })
                                                }}
                                                checked={this.state.scheduleListReferral.hideDurationForPatient}
                                                label={'Hide duration for patient'.translate(this.props.lang)}
                                            />
                                            <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                                <Isvg src={infoIcon} style={{ width: 25 }} />
                                                <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'Duration is not displayed to the patient.'.translate(this.props.lang)}</div>
                                            </div>
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.listDoctor ?
                                        <FormGroup>
                                            <Label className='note-label-wrap'>{'Note'.translate(this.props.lang)}
                                                <div className={this.state.scheduleListReferral?.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                                    <Isvg src={notesIcon} />
                                                    <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                                </div>
                                            </Label>
                                            <Input type='textarea'
                                                name="note"
                                                style={{ height: '150px' }}
                                                onChange={(e) => {
                                                    let scheduleListReferral = this.state.scheduleListReferral;
                                                    scheduleListReferral.patientNote = e.target.value;
                                                    this.setState({
                                                        scheduleListReferral
                                                    })
                                                }}
                                                value={this.state.scheduleListReferral.patientNote}
                                            />
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.scheduleListReferral?.rescheduledMessage ?
                                        <div className='rescheduled-message-schedule-modal'>
                                            *{this.state.scheduleListReferral?.rescheduledMessage}
                                        </div>
                                        :
                                        null
                                }
                                {
                                    this.state.listDoctor ?
                                        <FormGroup>
                                            <Button onClick={() => this.setState({
                                                doctorsModal: 5
                                            })} color="primary">
                                                {'Add caregiver'.translate(this.props.lang)}
                                            </Button>
                                        </FormGroup>

                                        :

                                        null
                                }


                                <Button color='primary' disabled={this.state.listDoctor ? false : true} onClick={() => {
                                    if (this.state.scheduleListReferral.status === 'requested-new-appointment') {
                                        this.listScheduleReferral({ ...this.state.scheduleListReferral, rescheduleReferral: true })
                                    } else {
                                        this.listScheduleReferral({ ...this.state.scheduleListReferral, rescheduleReferral: false })
                                    }
                                }}>{'Schedule referral'.translate(this.props.lang)}</Button>
                            </ModalBody>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.showPatientNotes && this.state.scheduleListReferral ?
                        <PatientNotesPreview
                            {...this.props}
                            isOpen={this.state.showPatientNotes}
                            items={this.state.scheduleListReferral?.patientNotes}
                            toggle={() => this.setState({ showPatientNotes: !this.state.showPatientNotes })}
                            showInModal={true}
                        />
                        :
                        null
                }
                {
                    this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}

                        >
                            {this.state.error.translate(this.props.lang)}
                        </ErrorModal>

                        :
                        null
                }
                {
                    this.state.signinModal ?
                        <Modal isOpen={this.state.signinModal} centered toggle={() => this.setState({ signinModal: !this.state.signinModal })} >
                            <ModalHeader>
                                <h4>{'Sign in with your NET ID'.translate(this.props.lang)}</h4>
                            </ModalHeader>
                            <ModalBody>
                                <Button onClick={() => this.allowReferral({})}>{'Continue'.translate(this.props.lang)}</Button>
                            </ModalBody>
                        </Modal>
                        : null
                }

                {
                    this.state.scheduleReferral ?
                        <Modal isOpen={this.state.scheduleReferral} centered>
                            {/* <ModalHeader style={{ margin: 'auto' }}>{'Schedule case'.translate(this.props.lang)}</ModalHeader> */}
                            <ModalBody className='delete-modal'>
                                {/* <Isvg src={QuestionMark} /> */}
                                <p className='message'>{'Do you want to schedule the selected referral?'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => {
                                    this.props[0].history.push(`/my-data/referrals/working-hours`)
                                }}>{'Yes'.translate(this.props.lang)}</Button>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({
                                    scheduleReferral: false
                                })}>{'No'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        : null
                }
                {
                    this.state.referralNote ?
                        <Modal size='lg' centered isOpen={this.state.referralNote}>
                            <ModalHeader style={{ paddingBottom: 0 }}>{'Notes'.translate(this.props.lang)}</ModalHeader>
                            <ModalBody className="delete-modal">
                                {
                                    this.state.referralNote?.patientNotes ?
                                        <div className='patient-notes-preview-wrap'>
                                            <PatientNotesPreview
                                                {...this.props}
                                                isOpen={true}
                                                items={this.state.referralNote?.patientNotes}
                                                caseId={this.state.patientNotesReferralId}
                                                toggle={() => { }}
                                                showInModal={false}
                                            />
                                        </div>
                                        :
                                        <div style={{ marginBottom: 20, display: 'flex', fontStyle: 'italic' }}> {'There are still no notes added.'.translate(this.props.lang)}</div>
                                }
                                <Input
                                    type="textarea"
                                    placeholder={'Enter new note'.translate(this.props.lang)}
                                    style={{ height: 100 }}
                                    value={this.state.referralNote.note}
                                    onChange={(e) => {
                                        let referralNote = this.state.referralNote;
                                        referralNote.note = e.target.value;
                                        this.setState({ referralNote })
                                    }}
                                />
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10 }} onClick={() => {
                                    this.updateReferralNote(this.state.referralNote)
                                }}>{'Save'.translate(this.props.lang)}</Button>

                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ referralNote: null })

                                }>{'Close'.translate(this.props.lang)}</Button>


                            </ModalFooter>
                        </Modal> : null
                }

                {/* {
                    this.state.referralNote ?
                        <Modal isOpen={this.state.referralNote} centered>
                            <ModalHeader style={{ margin: 'auto' }}>{'Note'.translate(this.props.lang)}</ModalHeader>
                            <ModalBody className="delete-modal">
                                <Input type="textarea" style={{ height: 100 }} value={this.state.referralNote.note} onChange={(e) => {
                                    let referralNote = this.state.referralNote;
                                    referralNote.note = e.target.value;
                                    this.setState({ referralNote })
                                }} />
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10 }} onClick={() => {
                                    this.updateReferralNote(this.state.referralNote)
                                }}>{'Save'.translate(this.props.lang)}</Button>

                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ referralNote: null })

                                }>{'Close'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>


                        :
                        null
                } */}
            </div>
        )
    }
}

const selector = formValueSelector('modalForm');

export default connect(state => ({
    group: selector(state, 'group'),
}, {
    changeSubgroup: value => change('modalForm', 'subgroup', value),
}))(PageWithLayout(ExternalBookingsList));